export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    abbr_day_names: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    month_names: [
      null,
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    abbr_month_names: [
      null,
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    order: ['year', 'month', 'day'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '$',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Bytes',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'Thousand',
          million: 'Million',
          billion: 'Billion',
          trillion: 'Trillion',
          quadrillion: 'Quadrillion',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'half a minute',
      less_than_x_seconds: {
        one: 'less than 1 second',
        other: 'less than %{count} seconds',
        few: 'less than %{count} seconds',
        many: 'less than %{count} seconds',
      },
      x_seconds: {
        one: '1 second',
        other: '%{count} seconds',
        few: '%{count} seconds',
        many: '%{count} seconds',
      },
      less_than_x_minutes: {
        one: 'less than a minute',
        other: 'less than %{count} minutes',
        few: 'less than %{count} minutes',
        many: 'less than %{count} minutes',
      },
      x_minutes: {
        one: '1 minute',
        other: '%{count} minutes',
        few: '%{count} minutes',
        many: '%{count} minutes',
      },
      about_x_hours: {
        one: 'about 1 hour',
        other: 'about %{count} hours',
        few: 'about %{count} hours',
        many: 'about %{count} hours',
      },
      x_days: {
        one: '1 day',
        other: '%{count} days',
        few: '%{count} days',
        many: '%{count} days',
      },
      about_x_months: {
        one: 'about 1 month',
        other: 'about %{count} months',
        few: 'about %{count} months',
        many: 'about %{count} months',
      },
      x_months: {
        one: '1 month',
        other: '%{count} months',
        few: '%{count} months',
        many: '%{count} months',
      },
      about_x_years: {
        one: 'about 1 year',
        other: 'about %{count} years',
        few: 'about %{count} years',
        many: 'about %{count} years',
      },
      over_x_years: {
        one: 'over 1 year',
        other: 'over %{count} years',
        few: 'over %{count} years',
        many: 'over %{count} years',
      },
      almost_x_years: {
        one: 'almost 1 year',
        other: 'almost %{count} years',
        few: 'almost %{count} years',
        many: 'almost %{count} years',
      },
      x_years: {
        one: '1 year',
        other: '%{count} years',
      },
      x_weeks: {
        one: '1 week',
        other: '%{count} weeks',
        few: '%{count} weeks',
        many: '%{count} weeks',
      },
      x_hours: {
        one: '1 hour',
        other: '%{count} hours',
      },
    },
    prompts: {
      year: 'Year',
      month: 'Month',
      day: 'Day',
      hour: 'Hour',
      minute: 'Minute',
      second: 'Seconds',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
    set_custom_wallpaper: 'Set custom wallpaper',
    set_custom_wallpaper_description:
      "Give this transfer its very own wallpaper to make a great impression when people download your files—don't worry, this won't change your ",
    default_settings: 'default settings',
    upload: 'Upload',
    reset_default: 'Reset to default',
    survey_link: 'Let us know what you think',
    file_rules:
      'JPEG/PNG %{minWallpaperWidth}x%{minWallpaperHeight}, %{maxUploadSize}MB max',
    storage_size_max: 'max',
    pop_over: {
      new_feature: 'New feature',
      try_now: 'Try now',
      not_today: 'Not today',
      hide_forever: 'Hide forever',
      hint: 'Psst, you can give any transfer its very own wallpaper without changing these settings—just set a custom wallpaper before sending a transfer.',
      introductory_upsell:
        'Psst, you can now give this transfer its very own wallpaper.',
    },
  },
  page: {
    plus: {
      button: {
        text: 'Upgrade to Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Up to five different images',
        best_2: 'JPEG or PNG',
        best_3: 'Up to %{size}',
        best_4: '%{resolution} pixels or more',
        best_5: 'No GIFs or videos (sorry)',
        best_title: 'The important bits:',
        text: 'Put yourself or your brand front and center with up to five rotating videos or images:',
        best_five: '%{videoResolution} pixels for videos',
        best_four: '%{resolution} pixels for images',
        best_one: 'Up to five videos or images',
        best_six:
          'Image wallpapers rotate every %{rotationInterval} secs, videos longer than %{rotationInterval} secs will be cut short',
        best_three: '%{size} max per video/image',
        best_two: 'JPEG, PNG or MP4',
        notice:
          "Drumroll please — video wallpapers have landed! <a href='/profile'>Make your background a video now</a>.",
      },
      upsell: {
        benefit_one_alt: 'Get your own WeTransfer page',
        heading_alt: 'Deliver your work in style',
        benefit_one: 'Get your own WeTransfer domain',
        benefit_three: 'Design your transfer emails',
        benefit_two: 'Show custom wallpapers when people download your files',
        button: {
          action: 'Tell me more',
        },
        heading: 'Show off your brand with WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send the best.</strong> Make a great impression every time people download your files.<br /> <strong>Receive with ease.</strong> Anyone can upload files to you as part of your plan.',
        protip: {
          text: '<strong>Pro tip:</strong> Requesting a transfer from someone? Share a special link to pre-fill the description for them.',
          link: 'Learn more',
        },
      },
      pagename: 'Branding',
      'onboarding-step-two':
        "Present your files in style, personalize your WeTransfer page and admire your new look at <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Customize your emails',
      sent_you_files: 'sent you some files',
      email_background_instruction_with_spec:
        'Add an image to make your transfer emails stand out. For best results, your image should be %{resolution} pixels (or we’ll crop it to fit). The maximum file size is %{size}.',
      receiving: 'Profile email',
      choose_wallpapers: 'Add your wallpapers',
      'step-one-banner':
        'To get started, choose a URL for your WeTransfer page. You can always change this later.',
      description: {
        pro: 'Your WeTransfer page lets you make a great impression every time people download your files. This is also where anyone can send you 200 GB transfers, as part of your WeTransfer Pro plan.',
        premium:
          'Your WeTransfer page lets you make a great impression every time people download your files. This is also where anyone can send you transfers with no file size limits, as part of your WeTransfer Premium plan.',
      },
      'instructions-1': 'Change your name and URL as many times as you need.',
      'instructions-2':
        'Once you’ve chosen a new URL, your page will be updated right away.',
      title: 'Edit your page',
      profile_url: 'URL',
    },
    payment: {
      never_actived_retry:
        'Your account is not active yet. Complete your registration to get started with <a href="/payment/retry">%{planName}</a>',
      pagename: 'Plan and payment',
      autorenew_heading: 'Payment details',
      autorenew_notice:
        'Your %{planName} subscription of %{deal} will be renewed automatically on %{autorenewal_attempt}.',
      will_expire_notice:
        "Your Pro subscription will <span class='payment__notice'>expire in %{daysBetween} days</span>. Renew your account now or set up automatic renewal.",
      never_actived_notice:
        'Your account is not active yet. <a href="/payment/retry">Complete your registration to get started with Pro.</a>',
      manual_renewal_expiry_notice:
        'Your Pro account will expire on %{expiry}.',
      to_checkout: 'Go to checkout',
      updating: 'Updating...',
      yes_disable: 'Yes, go ahead',
      review_billing_link: 'Update your payment method?',
      autorenew_failed:
        "Your Pro subscription of %{deal}/%{period} will <span class='payment__notice'><strong>expire in %{daysBetween} days</strong>. We couldn't renew your account for you – please renew your account manually before <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Are you sure you want to stop automatic renewal?',
      disable_autorenewal: 'Stop automatic renewal',
      enable_autorenewal: 'Enable automatic renewal',
      renew_now: 'Renew now',
      subscription_expired: 'Your Pro subscription has ended.',
      cancel_heading: 'Time to move on?',
      cancel_info:
        'We get it, these things happen. Once you cancel your subscription we’ll hold onto your files for another 30 days (no not under our pillow - don’t make it weird), in case there’s anything you’ve left behind. You can also reopen your subscription whenever you like.',
      cancel_info_subscription:
        'We get it, these things happen. Once you cancel your subscription, you’ll be able to use your Pro account until %{subscriptionExpiryDate}. After that we’ll hold onto your files for another 30 days (no not under our pillow - don’t make it weird), in case there’s anything you’ve left behind. You can also reopen your subscription whenever you like.',
      cancel_now: 'Cancel subscription',
      cancelling: 'Cancelling...',
      confirm_cancel_subscription:
        'Are you sure you want to cancel your subscription?',
      confirm_reactivate_subscription:
        'Excellent choice! Just one more click to reactivate your payment method',
      manual_renewal_in_future_notice:
        'Your Pro subscription of %{deal}/%{period} will expire in %{daysBetween} days. You can manually renew your account after %{manual_renewal_available_at}, or activate automatic renewal now.',
      reactivate_heading: 'Let’s start over.',
      reactivate_content_top_pro:
        'You can reactivate your %{planName} subscription and it’ll be like you never cancelled. Or you can choose to upgrade to WeTransfer Premium:',
      reactivate_content_top_premium:
        'You can reactivate your %{planName} subscription and it’ll be like you never cancelled.',
      reactivate_content_bottom_pro:
        'If you upgrade to Premium, you will be charged %{upfront_payment} and you’ll be able to get started with WeTransfer Premium right away. Your new subscription of %{recurring_payment}/%{interval} will be renewed on %{recurring_date}.',
      reactivate_pro: 'Reactivate Pro',
      reactivate_premium: 'Reactivate Premium',
      reactivate_upgrade_to_premium: 'Upgrade to Premium',
      reactivating: 'Reactivating...',
      subscription_cancelled:
        'Your subscription has been cancelled and will automatically expire in %{daysBetween} days.',
      subscription_reactivate_expired_notice:
        'Your Pro account has been cancelled.',
      subscription_reactivate_notice_pro:
        'Your %{planName} subscription has been cancelled and will end in %{daysBetween} days.',
      subscription_reactivate_notice_premium:
        'Your %{planName} subscription has been cancelled and will end in %{daysBetween} days.\nChanged your mind? Don’t panic, it’s easy to get things back up and running.',
      subscription_reactivate_notice_trial_before:
        'Your %{planName} subscription has been cancelled and will end in %{daysBetween} days.\nYou can continue to enjoy your WeTransfer Premium trial until your subscription ends.',
      subscription_reactivate_notice_trial_after:
        'Your %{planName} subscription has been cancelled and will end in %{daysBetween} days.\nYou can continue to enjoy your WeTransfer Premium trial until %{trialExpiryDate}.',
      update_method_link: 'Update payment details',
      autorenew_notice_teams:
        'Your %{planName} subscription of %{deal} will be renewed automatically for your team of %{number_of_members} members on %{autorenewal_attempt}.',
      cancellation_cta: 'Cancel subscription',
      cancellation_heading: 'No longer need the benefits of %{planName}?',
      cancellation_heading_trial: 'Cancel subscription',
      cancellation_text:
        'If you cancel your subscription, you’ll be able to use your Pro features until %{subscriptionExpiryDate}. After that, your WeTransfer Pro account will be converted to a free account and your existing transfers will expire 28 days later.',
      cancellation_text_item_1: 'Send up to %{transfer_limit}',
      cancellation_text_item_2: 'Password-protect transfers',
      cancellation_text_item_3:
        'Manage and store %{storage_limit} of transfers',
      cancellation_text_item_4: 'Have your own URL and custom Pro page',
      cancellation_text_item_heading:
        'A free account only allows you to send %{free_size_limit} per transfer. You’ll no longer be able to:',
      cancellation_text_new:
        'If you cancel your subscription now, you’ll be able to use %{planName} until on %{subscriptionExpiryDate}. After that, you’ll be downgraded to the free plan.<br /><br />Heads up, any existing transfers will expire no later than 28 days after your subscription ends.',
      cancellation_text_teams:
        'If you cancel your subscription now, you and your team will be able to use %{planName} until on %{subscriptionExpiryDate}.<br /><br />After that, you and your team members will no longer be able to send file transfers, create presentation slides, and make boards together. You’ll be downgraded to the free plan and you will only be able to log in to your own WeTransfer account.<br /><br />Heads up, any existing transfers will expire no later than 28 days after your subscription ends.',
      premium_trial: {
        feature_list_item_1: 'No size limits on transfers',
      },
      premium_upgrade: {
        cta: 'Switch to Premium',
        description:
          'You will be charged %{upfront_payment} and you’ll be able to get started with WeTransfer Premium right away. Your new subscription of %{recurring_payment}/%{interval} will be renewed on %{recurring_date}.',
        feature_list_item_1: 'Send transfers with no file size limits',
        feature_list_item_2: 'Unlimited storage',
        feature_list_item_3: 'Unlimited portals and reviews',
        feature_list_item_4: '%{storageLimit} storage',
        heading: 'Want to upgrade your plan?',
      },
      unpaid_invoices: {
        heading: 'You have unpaid invoices',
        item: {
          issued_on: 'Issued on',
          pay_invoice: 'Pay invoice',
          pending_invoice: 'Pending...',
        },
        subheading:
          'Looks like there was an issue with your previous payments. Please pay any outstanding invoices or your Pro subscription may be cancelled.',
        subheading_2:
          'If you have pending invoices, sit tight—we’ll try again in a couple of days and you’ll be good to go once the payment is successful.',
      },
      upgrade_cta: 'Upgrade',
      app_subscription_banner: {
        title: "You're subscribed from the %{app_name}",
        content:
          'To view or manage your subscription, log in to your %{app_name} account from your phone or computer.',
        go_to: 'Go to',
        learn_more: 'Learn more',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Cancel subscription',
      cancellation_disclaimer:
        '*Heads up, your existing transfers will expire no later than 28 days after your account is downgraded.',
      'current-plan': 'Current plan',
      'free-forever': 'Free forever',
      'free-usp-1': 'Send up to 2 GB',
      'free-usp-2': 'No storage',
      'free-usp-3': 'Transfers expire after 7 days*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'If you cancel your subscription now, you’ll be able to continue using WeTransfer Pro until <b>%{expiration_date}</b>. After that, you’ll be downgraded to a free WeTransfer account—which is still pretty great.',
      pagename: 'No longer need the benefits of Pro?',
      'pro-usp-1': 'Send and receive up to %{transfer_limit}',
      'pro-usp-2': '1 TB storage',
      'pro-usp-3': 'Decide when transfers expire',
      'pro-usp-4':
        '<p>Your own <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro page</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Unlock Paste® Pro and Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>You’ve now cancelled your subscription and you’ll be downgraded to a free WeTransfer account after <b>%{ends_at}.</b></p>\n<p>Please tell us your reason for leaving so we can improve WeTransfer with you in mind.</p>',
      reason_header: 'We’re sad to see you go',
      cancel: 'Go back',
      info: 'Tell us your reason for leaving and we’ll continue to improve WeTransfer Pro with you in mind.',
      pagename: 'Before you go',
      yes_disable: 'Yes, go ahead',
    },
    payment_failed: {
      selected_product: 'One %{duration} of %{planTier}',
      change: 'Update',
      complete_order: 'Complete your order',
      description: 'Review your details and complete your order',
      description_error:
        'Something went wrong — review your details and continue to checkout',
      description_refused:
        "We couldn't process your payment — please check your payment details and try again",
      discount: 'Discount',
      product_description: 'One %{duration} of WeTransfer Pro',
      title: "You're nearly there!",
      total: 'Total',
      vat: 'VAT',
      your_details: 'Your details',
      your_order: 'Your order',
      title_error: 'Hmmm there seems to be an issue',
      title_refused: 'Hmmm there seems to be an issue',
      payment_status_message:
        'Your payment was successful, but something went wrong, and we couldn\'t update your plan automatically. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Get in touch with support</a>',
    },
    payment_methods: {
      billed_now: 'Billed now',
      info_content: {
        cancel_bullet:
          "Don't worry, you can find the option to cancel in Account Settings > Payment.",
        initial_payment_bullet:
          "After the initial payment you'll be charged %{price} %{interval} (unless you decide to cancel your subscription - but you wouldn't, right? Right?!)",
        update_payment_bullet:
          'You can always update your payment details and/or billing information before your next payment is due.',
        month:
          "- After the initial payment you'll be charged %{price} every month (unless you decide to cancel your Pro subscription - but you wouldn't, right? Right?!)\n- Don't worry, you can find the option to cancel in Account Settings > Payment.\n- You can always update your payment method and/or business details before your next payment is due.",
        year: "- After the initial payment you'll be charged %{price} once a year (unless you decide to cancel your Pro subscription - but you wouldn't, right? Right?!)\n- Don't worry, you can find the option to cancel in Account Settings > Payment.\n- You can always update your payment method and/or business details before your next payment is due.",
      },
      payment_cta: 'Complete payment',
      payment_term: {
        monthly: 'once a month',
        yearly: 'once a year',
      },
      payment_title: 'Payment',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Monthly',
        year: 'Yearly',
      },
      subtotal: 'Sub-total',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Your payment method',
      bancontact: 'Bancontact',
      card: 'Credit card',
      card_cvc: 'CVC',
      card_expiration: 'MM / YY',
      card_name: 'Name on card',
      card_number: 'Card number',
      complete_payment: 'Complete your payment',
      creditcard: 'Credit card',
      discount: 'Discount',
      do_not_refresh:
        'Try and resist the temptation to refresh or close this page',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL is an online payment method used in the Netherlands where users can pay directly from their bank account',
      info: 'Update payment method',
      payment_in_progress: 'Processing your payment...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/month',
        year: '/year',
      },
      select_bank: 'Select your bank',
      select_country: 'Select country',
      sofort: 'SOFORT',
      tax: 'VAT',
      title: 'Select your payment method',
      total: 'Total',
    },
    projects: {
      actions: {
        go_back: 'All projects',
        discard: 'Discard changes',
        edit: 'Edit',
        remove_transfer:
          'Delete this transfer? Files will be removed from this project and sent transfers.',
        save: 'Save',
        share: 'Share',
      },
      transfer_actions: {
        download: 'Download',
      },
      added_at: 'at %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Copy link',
        link_copied: 'Link copied to clipboard',
        content_label: 'Copy link to this project',
        list_item_1: 'Download and view access only',
        list_item_2: 'Link stays the same, forever',
        title: 'Share project',
      },
      content: {
        empty_state:
          'Your project is currently empty. Get started by adding some files to start your project timeline.',
      },
      logo_title: 'Go back to wetransfer.com',
      logo_tooltip_caption: 'Back to WeTransfer',
      timestamp: '%{timeAgo} ago',
      chat: {
        owner_button_label: 'Psst… Talk to us',
        owner_offline_greeting:
          'We’re currently offline, but let us know what you’re having trouble with and we’ll get back to you within one business day.',
        owner_online_greeting:
          'Let us know what you’re having trouble with and we’ll get back to you as soon as we can',
        receiver_button_label: 'Questions? We’re here to help',
        receiver_offline_greeting:
          'Let us know what you’re having trouble with and we’ll get back to you as soon as we can.',
        receiver_online_greeting:
          'Let us know what you’re having trouble with and we’ll get back to you as soon as we can.',
      },
      created_by: 'Created by %{user}',
      created_by_fallback: 'Created',
      deliverable_clipboard_modal: {
        content_label: 'Copy link to this deliverable',
        info: 'People will also be able to see your project',
        title: 'Share deliverable',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'This is not the Project you’re looking for…',
        limit:
          "Your potential is infinite, but you've reached your character limit",
        required: 'You know the drill. You can’t skip filling this out',
      },
      event: {
        project_created_byline:
          'Add some files to show what you’re working on.',
        project_created_title: 'Start of project',
      },
      file_count: {
        one: '%{count} file',
        other: '%{count} files',
      },
      just_now: 'just now',
      labels: {
        description: 'Description',
        name: 'Name',
        new_name: 'Name your project',
      },
      logo: {
        cta: 'Add a logo',
        errors: {
          dimensions:
            'Your logo is smaller than 220 x 220 px. Try a bigger image',
          general: 'Hmm, something went wrong. Please give it another go',
          size: 'Your logo is bigger than 5 MB. Try a smaller file',
          type: 'Your logo is not a JPEG, GIF, or PNG. Try a different image',
        },
        instructions:
          'Your logo can be up to 5 MB. JPEGs and GIFs are okay, but PNGs with a transparent background work best',
        'instructions-title': 'Show off your brand',
      },
      name_modal: {
        content_label: 'Name or rename your Project',
        input_placeholder_0: 'Definitely a Cannes Lion',
        input_placeholder_1: 'A cure for the common cold',
        input_placeholder_2: 'The perfect crime',
        input_placeholder_3: 'I Write Songs Not Titles',
        input_placeholder_4: 'Award-Winning Idea',
        input_placeholder_5: 'Brand New Brand Campaign',
        input_placeholder_6: 'World domination',
        save: 'Save',
        text: 'Describe what you’re working on.',
        title: 'Name your project',
      },
      new_project_label: 'Start new project',
      noticebar: {
        'button-cancel': 'Cancel',
        'button-clear-all-files': 'Clear all',
        'button-close': 'Close',
        'button-delete': 'Delete',
        'button-no': 'No',
        'button-share': 'Share',
        'button-yes': 'Yes',
        'confirm-cancel': 'Cancel this transfer?',
        'confirm-clear-files-deliverable':
          'Clear all files from <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Upload complete! Let everyone know that you’ve added more files.',
        'confirm-delete-deliverable':
          'Delete <strong><u>%{deliverableName}</u></strong> and any files you’ve uploaded to it?',
        'confirm-first-complete':
          'Upload complete! Share this project for your files to be downloaded.',
        deliverable_not_found_error:
          'Hmm, looks like that deliverable has been deleted',
        general_error: 'Yikes, something went wrong. Please try again.',
      },
      'onboarding-promise': {
        description:
          'Outline all the work you’ll deliver for a project and streamline the way you share. Create a list of deliverables, then add files as you progress—no more different download links.',
        title: 'Start on track to stay on track',
      },
      onboarding: {
        banner:
          'Heads up! You’re one of a chosen few with access to Projects while it is still being built (and improved on). We might reach out to you for feedback.',
      },
      pagename: 'Projects',
      placeholders: {
        description: 'Give your project a brief description',
        loading: 'Loading...',
      },
      project: {
        notification: {
          name_saved: 'Name saved! Your project sounds like a winner.',
        },
      },
      share_button_label: 'Share',
      unnamed_project_title: 'Unnamed Project',
      watch_video: 'Watch video',
    },
    transfer: {
      display_name_fallback: 'Untitled transfer',
      does_not_expire: 'no <u>expiration date</u>',
      expires_in: 'Expires in <span>%{time}</span>',
      downloaded_at: 'Downloaded %{date}, at %{time}',
      not_downloaded: 'Not yet downloaded',
      email_bounced: "Hmm, the email address you sent this to didn't work",
      count_files: {
        one: '%{count} file',
        other: '%{count} files',
      },
      sent_datetime: 'Sent %{date} at %{time}',
      never_expires: 'No expiration date',
      and_more: 'And %{count} more',
      read_more: 'more',
      copy_link: 'copy link',
      message: 'Message',
      total_downloads: 'Total downloads',
      sent_to_recipients: {
        one: 'Sent to %{count} person',
        other: 'Sent to %{count} people',
      },
      no_transfers: 'All the transfers you send will appear here',
      add_first_description:
        'Check the download status or edit, forward or delete them',
      mobile: {
        download: 'Download all files',
        remove: 'Delete transfer',
      },
      delete_datetime: 'Files deleted %{date} at %{time}',
      detail: {
        plus_download_stats:
          'Get Pro to keep track of how many times your transfers are downloaded.',
        plus_password_expiration:
          'Get Pro to set passwords and expiration dates on your transfers.',
        plus_transfer_actions:
          'Get Pro to manage your transfers and delete them anytime.',
        title: 'Your transfer details',
      },
      download_status_email: '%{count}/%{total} people',
      download_status_email_text: {
        zero: 'Not yet downloaded',
        one: '%{count}/%{total} people',
        other: '%{count}/%{total} people',
      },
      download_status_link: {
        one: 'one time',
        other: '%{count} times',
      },
      download_status_link_text: {
        zero: 'Not yet downloaded',
        one: '1 time',
        other: '%{count} times',
      },
      sent_moment: 'Sent %{moment}',
      total_downloads_tooltip:
        "Different than you expected? We've recently made a small change. This number shows only completed downloads.",
      display_name: {
        label: 'Title',
        label_mobile: "Add a title so people know what's in your transfer",
      },
      download_status_received_text: {
        zero: 'Not yet downloaded',
        one: 'Downloaded',
        other: 'Downloaded',
      },
      edit_display_name: {
        cancel: 'Cancel',
        save: 'Save',
        title: 'Title',
      },
      received_datetime: 'Received %{date} at %{time}',
      received_from: 'Received from',
      received_moment: 'Received %{moment}',
      teams: {
        received_by: 'Received by',
        self: 'me',
        sent_by: 'Sent by',
      },
      title: 'Title',
      set_password: {
        added: 'Added',
        change: 'Change',
        remove: 'Remove',
        description:
          'Set a password to control who has access to this transfer.',
        remove_warning: 'Remove password protection from this transfer?',
        yes_remove: 'Yes, remove',
      },
      set_expiration: {
        description: 'Set an expiration date to limit access to this transfer.',
        label: 'Expires in',
      },
      anon_upsell_no_account:
        'To edit or track downloads for this transfer before it expires, <a href="%{href}">sign up</a> for free.',
      anon_upsell_found_account:
        'To edit or track downloads for this transfer before it expires, <a href="%{href}">login</a>.',
      anon_upsell_no_account_with_button:
        'You can edit this transfer before it expires by creating an account.',
      create_free_account: 'Create free account',
    },
    transfers: {
      space_used_unlimited: ' %{space} of storage used',
      pagename: 'Transfers',
      search: 'search for filename',
      search_results: {
        one: '%{count} search result',
        other: '%{count} search results',
        none: 'No results',
        retry:
          'Looks like we couldn’t find a transfer matching your search - have another go.',
      },
      space_used: '%{space} of %{totalSpace} used',
      selected_text: {
        one: '%{count} transfer selected (%{size})',
        other: '%{count} transfers selected (%{size})',
      },
      last_7_days: 'Sent in the last 7 days',
      over_7_days: 'Sent more than 7 days ago',
      sort_on: 'Sort by:',
      size: 'Size',
      name: 'Name',
      date: 'Date',
      delete: 'Delete',
      download: 'Download',
      forward: 'Forward',
      remove: 'Delete',
      select: 'Select',
      copy_link: 'Copy link',
      sent_time_ago: 'Sent %{timeAgo} ago',
      files: {
        one: '%{count} file',
        other: '%{count} files',
      },
      confirm_transfer_delete:
        'Hold up – are you sure you want to delete this transfer?',
      confirm_forward:
        'Forwarding this will replace the transfer in progress. Continue?',
      confirm_expired_transfer_delete:
        'This will delete the files and the transfer info forever. Continue?',
      deleting_now: "We're deleting this for you now",
      deselect_all_transfers: {
        one: 'Deselect all transfers',
        other: 'Deselect all %{count} transfers',
      },
      downloads: 'Downloads',
      expiration: 'Expiration date',
      expiration_next: 'Expires next %{days}',
      expiration_no_date: 'No expiration date',
      expiration_not_soon: 'Doesn’t expire soon',
      include_archived_switch_label: 'Include info for deleted transfers',
      include_archived_switch_tooltip:
        "These don't count towards your storage limit",
      notify_completed:
        "Transfer completed. You can close this panel. Or keep looking at it, that's cool too.",
      preview: 'Preview',
      remove_permanently: 'Remove info forever',
      search_placeholder: 'Search by file name or email',
      select_all_transfers: {
        one: 'Select all transfers',
        other: 'Select all %{count} transfers',
      },
      space_left: '%{space} of %{totalSpace} left',
      teams_tip: {
        subtitle:
          'This page shows you your own transfer activity. In case you were wondering, your team members can only see their own transfers too.',
        title: 'Your Pro team is growing…',
      },
      title: 'Sent transfers',
      view_details: 'View details',
      edit_display_name: 'Edit title',
      received_time_ago: 'Received %{timeAgo} ago',
      search_title_placeholder: 'Search by title, file name, or email',
      see_all: 'See all (%{count})',
      sender: 'Sender',
      sort_by_title: 'Title',
    },
    accountinfo: {
      pagename: 'Account information',
      signed_in_as: 'Signed in as %{name}',
      sign_out: 'Sign out',
      paid_on: 'Paid on',
      no_invoices:
        "Your receipts will show up here, but it looks like you haven't got any yet. Lucky you!",
      subscription_info:
        'Your Pro subscription of %{deal} will be renewed automatically on %{autorenewal_attempt}.',
      payment_success: {
        monthly: 'Nice - you’re all set for a full month of WeTransfer Pro',
        monthly_renewal: 'Nice - you’re all set for another month of Pro',
        yearly: 'Nice - you’re all set for a full year of WeTransfer Pro',
        yearly_renewal: 'Nice - you’re all set for another year of Pro',
      },
    },
    changepassword: {
      pagename: 'Change password',
    },
    invoices: {
      pagename: 'Receipts',
    },
    reviewbilling: {
      pagename: 'Confirm your payment details',
      information:
        'In order to change your payment method, we’ll need to renew your subscription at the same time',
      information_payment:
        'You will be charged %{deal} for the next %{period} of Pro – your subscription will be good until %{expiry}',
    },
    renewbilling: {
      pagename: 'Review your information and renew',
    },
    link_downloads_unsubscribe: {
      body: 'You can unsubscribe from notifications about link transfer downloads – you’ll still be able to keep track of downloads in your Sent panel.',
      cta: 'Go to my Sent transfers',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Pick from gallery',
        },
        next_button: 'All set',
        description:
          'Choose your own wallpapers for your shiny new WeTransfer page. You can add up to five rotating videos or images to put yourself or your brand front and center.',
      },
      upload_wallpaper: {
        add_text: 'Upload an image',
        add_description:
          'For the best possible results, we suggest you upload an image at 2560 x 1600 pixels. Maximum file size is 3MB.',
        upload_text: 'Upload an image or video',
      },
      preview: {
        wallpaper_credits_prefix: 'Wallpaper by',
      },
      1: {
        description:
          'Customize what people see every time you send them files. And with your own WeTransfer page, anyone can send you %{transfer_limit} transfers—just give them your URL. Your email address will be shown on the page so people can trust that their files will be sent to you.<br /><br />\nFirst up, choose your URL.',
        next: 'Next',
        skip: 'Skip',
        warning:
          '<strong>Heads up,</strong> you can only set this once (no pressure!)',
        'blurb-1':
          'Create your own WeTransfer page to look professional every time someone downloads your files, and make it (even) easier for anyone to send you transfers.',
        'blurb-2': 'First up, choose your URL.',
        welcome: 'Set the stage with your own WeTransfer page',
        information:
          'Don’t worry, you can always change this later in <strong>Branding</strong>.',
        description_unlimited:
          'Customize what people see every time you send them files. And with your own WeTransfer page, anyone can send you transfers of any size—just give them your URL. Your email address will be shown on the page so people can trust that their files will be sent to you.<br /><br />\nFirst up, choose your URL.',
      },
      2: {
        description:
          'You can select up to five different backgrounds (or wallpapers as we call them) for your WeTransfer page.\n\nPut yourself or your brand front and center and deliver your files in your style',
        pick: 'Pick from our gallery',
        title: 'Make an impression with every transfer',
        upload: 'Upload your own',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> is all set up. Now you can add this link to your website for people to send you %{transfer_limit} transfers—or, er, go send stuff.',
        done: 'Done',
        title: 'That looks great!',
        description_unlimited:
          '<strong>%{customLink}</strong> is all set up. Now you can add this link to your website for people to send you transfers of any size—or you can, er, go send stuff.',
      },
    },
    contact: {
      add_contact: 'Add contact',
      add_first_description:
        "We'll also save the email addresses you send files to here",
      add_to_transfer: 'Add to transfer',
      remove_from_transfer: 'Remove from transfer',
      confirm_delete: {
        one: 'Are you sure you want to delete this contact?',
        other: 'Are you sure you want to delete %{count} contacts?',
      },
      contact_count: {
        one: '%{count} contact',
        other: '%{count} contacts',
      },
      edit: 'Edit',
      mobile: {
        add: 'Add contact',
      },
      no_contacts: 'Add your first contact!',
      pagename: 'Contacts',
      remove: 'Delete',
      search_count: {
        one: '%{count} search result',
        other: '%{count} search results',
      },
      search_placeholder: 'search for email, name or company',
      select: 'Select',
      selected_text: {
        one: '%{count} contact selected',
        other: '%{count} contacts selected',
      },
      teams_tip: {
        subtitle:
          'When you send someone a transfer, we’ll add them to your contact list. Everyone in your team can build their own list.',
        title: 'Your Pro team is growing…',
      },
    },
    unsubscribeexpiration: {
      button: 'Unsubscribe',
      button_unsubscribed: 'Back to WeTransfer',
      description:
        'Had enough of our emails? No worries, we can stop reminding you when transfers are about to expire.',
      description_unsubscribed:
        'You won’t receive any more emails about expiring transfers',
      no_email: 'you',
      title: 'Unsubscribe from reminder emails',
      title_unsubscribed: 'All done!',
      downloaded: {
        body: 'Got it. You can unsubscribe from reminders that your transfers are about to expire when your files have already been downloaded. This won’t change whether or not we email you reminders when people haven’t downloaded your files yet.',
        cta: 'Unsubscribe',
        title:
          '“My files have been downloaded, I don’t need emails about expiring transfers”',
      },
      not_downloaded: {
        body: 'No problem. You can unsubscribe from reminders that your transfers are about to expire, even though people haven’t downloaded your files yet.',
        cta: 'Unsubscribe',
        title: 'Don’t need emails about expiring transfers?',
      },
      pro: {
        body_1:
          'That’s cool, you can unsubscribe from these reminders. In your transfer details, you’ll still be able to keep track of when transfers expire and change the expiration dates whenever you want.',
        body_2:
          'Psst, you can hit us up at <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> if you change your mind or get stuck with anything—no hard feelings.',
        cta: 'Unsubscribe',
        title: 'Don’t need emails about expiring transfers?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Are you sure you want to clear your cookies?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Upgrade to Pro today for %{currency}%{price}/month',
      },
    },
    advertise: {
      gallery: {
        preview: 'Preview',
      },
      guidelines: {
        advert_static: {
          title: 'Static wallpaper',
        },
      },
    },
    billinginfo: {
      pagename: 'Billing information',
    },
    help: {
      button_all_answers: 'More answers',
      page_title: 'Quick Help',
      read_more: 'Read more',
      search_button: 'Search',
      search_placeholder: 'What can we help you with?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Loading...',
    },
    payment_update: {
      bancontact: {
        info: 'Heads up – to check your details are correct Bancontact will charge a one-time fee of €0.50',
      },
      confirm_update: 'Confirm',
      ideal: {
        info: 'Heads up – to check your details are correct iDEAL will charge a one-time fee of €0.01',
      },
      info: 'Heads up – to check your details are correct iDEAL will charge a one-time fee of €0.01',
      sofort: {
        info: 'Heads up – to check your details are correct SOFORT will charge a one-time fee of €1',
      },
      title: 'Update payment details',
      update_in_progress: 'Updating your details...',
    },
    sign_in: {
      account: "Don't have an account?",
      upgrade: 'Upgrade to WeTransfer Pro',
    },
    signin: {
      account_cta: 'Create an account',
      account_item_1: 'Send up to %{size_limit}',
      account_item_2: 'Manage transfers',
      account_item_3: 'Store up to %{storage_limit}',
      account_subtitle: 'Free',
      plus_cta: 'Get WeTransfer Pro',
      plus_item_1: 'Send up to %{size_limit}',
      plus_item_2: 'Manage transfers',
      plus_item_3: 'Store up to %{storage_limit}',
      plus_item_4: 'Your own backgrounds',
      plus_item_5: 'A custom URL',
      plus_item_6: 'Password-protect transfers',
      plus_month: '/month',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Cancel invite',
      },
      invitees: {
        title: 'Invited – awaiting response',
      },
      member: {
        action_demote: 'Remove as admin',
        action_promote: 'Make admin',
        action_revoke: 'Take off team',
      },
      members: {
        title: 'On your team',
      },
      no_access: {
        description: 'Stay tuned, we’ll let you know when it’s ready. ',
        title: 'Oops, looks like this feature is still top secret. ',
      },
      subtitle: {
        members: {
          one: '%{count} member',
          other: '%{count} members',
        },
        pending: '%{pendingCount} invited',
      },
      tip: {
        button: 'Learn more',
        subtitle:
          'With our brand new Pro for Teams feature, we’ve made the best WeTransfer experience even better! Add new members for free. Use the super-simple form below to get your team going – once they accept your invite you are good to go!',
        title: 'There’s no i in team...',
      },
      title: 'Team',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Expires in %{expiry}',
      },
      recipients: 'Sending to',
      upsell: {
        benefit_one: 'See when your files were downloaded',
        benefit_three: 'Review and resend your old transfers',
        benefit_two: 'See who downloaded your files',
        button: {
          action: 'Tell me more',
          cancel: 'No, thanks',
        },
        heading: 'Manage your transfers easily with WeTransfer Pro',
        title: 'Your transfer details',
      },
    },
    transferReceived: {
      'empty-description':
        'Here you’ll find all transfers sent to you — don’t worry, they won’t use up any of your storage',
      'empty-title': 'Keep track of transfers',
      empty: {
        description:
          'Here you’ll find all transfers sent to your email or uploaded to you — don’t worry, they won’t use up any of your storage.',
      },
      banner: {
        freeUser: {
          text: 'Upgrade to receive with ease. Get a custom URL <strong>yourname.wetransfer.com</strong> and branded page for uploads.',
          link: 'Learn more',
          cta: 'Upgrade',
        },
        paidUser: {
          withUrl: {
            text: 'Anyone can send you 200 GB transfers at <strong>%{personalisedUrl}</strong>',
            cta: 'Copy URL',
          },
          withoutUrl: {
            text: 'Set your URL <strong>yourname.wetransfer.com</strong> and anyone can upload files to you.',
            link: 'Learn more',
            cta: 'Go to branding',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Unsubscribe',
      back: 'Back to WeTransfer',
      contact:
        'Psst, if you get stuck with anything you can hit us up at <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> — no hard feelings.',
      done: 'All done!',
      message:
        'You can unsubscribe from our introduction emails — don’t worry, you’ll still get the important stuff.',
      title: 'Inbox getting busy?',
    },
    userinfo: {
      pagename: 'Personal details',
    },
    free_onboarding: {
      close: 'Close',
      finish_tour: 'Done',
      next: 'Next',
      send_files: 'Just go to send files now',
      start_tour: "See what else we've got",
      step_one: {
        body_1:
          'Now that you’ve verified your email address for your account, there’s no need to do it every time you transfer. No more verification codes!',
        body_2:
          'Keep track of all your sent and received transfers in one place. See how many times your files are downloaded. Resend, forward, or delete your transfers with a click.',
        header_1: 'Verified once and for all',
        header_2: 'Manage your transfers',
        subtitle:
          'Say goodbye to verification codes and lost download links. Your new account gives you the simplest way to send big files—for free.',
        title_1: 'Send files <strong>on your terms</strong>',
        title_2: 'with WeTransfer',
      },
      step_three: {
        body_1:
          'Whether it’s a video on your phone or a link from your desktop, save all your inspiration in one place. To get started, open Collect with the launcher (that’s the thing in the top left corner) or use the link below.',
        cta: 'Go to Collect',
        title_1: '<strong>Save inspiration</strong> on the go',
        title_2: 'with Collect',
      },
      step_two: {
        body_1:
          'Pitch ideas. Show work in progress. Stay in sync. Without formatting another slide, ever again. To get started, open Paste with the launcher (that’s the thing in the top left corner) or use the link below.',
        cta: 'Go to Paste',
        title_1: 'Make <strong>slides in seconds</strong>',
        title_2: 'with Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Try out portals',
        pill: 'Fresh new feature',
        text: 'Introducing <strong>portals</strong>, a simpler way to get the sign off you need. Invite clients and collaborators to view files and select favorites—no downloads needed.',
        title: 'Share work. Get feedback. All in one place.',
      },
    },
    not_found: {
      body: 'Head back to <a href="https://wetransfer.com/">wetransfer.com</a> or cheer up your eyes with some <a href="https://wepresent.wetransfer.com/">nice things we wrote</a>.',
      image_alt: 'Something went wrong',
      title: 'Yikes, that page can’t be found.',
    },
    password_and_security: {
      title: 'Password and security',
      'two-factor-authentication': {
        description: {
          enabled: 'Since %{date}',
        },
        disable: 'Turn off',
        done: 'Done',
        enable: 'Turn on',
        get_recovery_codes: 'Get recovery codes',
        next_step: 'Next',
        recovery_code_action: 'Generate new codes',
        recovery_code_keep_safe:
          'Each code can only be used once, but you can always get more if you need them.',
        recovery_code_need_more:
          'Need more recovery codes? You can always generate new ones, just keep in mind that this will make all the current codes invalid.',
        recovery_code_title: 'Your recovery codes',
        require_password_action: 'Enter',
        require_password_text: 'Enter your password to continue',
        step_one_action: {
          app_store: 'Download on App Store',
          google_play: 'Get it on Google Play',
        },
        step_one_label: 'Step 1 (of 3)',
        step_one_text:
          'You will need an authenticator app on your phone. If you already have Google Authenticator (or a different app), click next.',
        step_one_title: 'Download Google Authenticator',
        step_three_label: 'Step 3 (you’re all set!)',
        step_three_text:
          'If you need to log in and don’t have your phone with you (we hear that it does happen), you can use one of these recovery codes. We won’t save these codes for you or show them to you again, so grab them now—and be sure to keep them as safe as the passcode to your bank account.',
        step_three_text_2:
          'Keep these codes as safe as your password to your bank account! Each code can only be used once.',
        step_three_title: 'Save recovery codes',
        step_two_form: {
          error: 'Uh-oh, that code is wrong or expired',
          label: 'Verification code',
        },
        step_two_label: 'Step 2 (halfway there)',
        step_two_text:
          'Use your authenticator app to scan this barcode. The app will generate a six-digit verification code; enter that code below.',
        step_two_text_mobile:
          'Enter this key in your authenticator app. The app will generate a six-digit verification code; enter that code below.',
        step_two_title: 'Scan barcode',
        step_two_title_mobile: 'Enter key',
        text: {
          protect_account:
            'Use your phone to add an extra layer of security to your account.',
        },
        title: 'Two-factor authentication',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Get the best of Paste® and Collect',
      },
      cta: 'No, I want to stay Pro',
      'cta-2': 'Cancel subscription',
      disclaimer: {
        collect: 'Your storage space will go from 200 GB to 5 GB in Collect',
        paste: 'You’ll go from having unlimited decks to 3 decks in Paste®',
        'team-member':
          'You’ll be removed from %{currentTeam} on WeTransfer Pro.',
        teams:
          'Your team of %{amountOfMembers} will be removed from %{currentTeam}',
        title:
          'When your current subscription ends on <strong>%{date}</strong>:',
        'transfer-expiry':
          'Your existing transfers will be deleted after 28 days',
        'transfer-team-member':
          'You won’t be able to send and receive transfers as part of the team, and you won’t be able to manage existing team transfers.',
      },
      'password-expiry': {
        title: 'Password-protect transfers and decide when they expire',
      },
      personalization: {
        title: 'Personalize your own WeTransfer page',
      },
      portals: {
        text: 'With %{planName}, you can use <a href="%{href}" target="_blank">portals</a> to share work for clients to review—no downloads needed.',
        title: 'Share work and get feedback in one place',
      },
      'stay-pro': 'Keep subscription',
      'storage-limit': {
        title: 'Keep %{storage_limit_pro} of transfer storage',
      },
      subtitle: "If you cancel now, from %{date} you'll no longer be able to:",
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Invite team members</a> to send, receive, and manage transfers together—or work alone for free.',
        'team-member-text':
          'You will be removed from your team and you will no longer be able to send, receive, or manage transfers together.',
        'team-owner-text':
          'You have <a href="%{href}" target="_blank">%{amountOfMembers} team members</a> who will will no longer be able to send, receive, or manage transfers together.',
        title: 'Work on big ideas as a team',
      },
      title: 'Are you really ready to give up %{planName}?',
      'transfer-limit': {
        text: 'Right now, you can send and receive bigger transfers—way more than the free %{transfer_limit_free}.',
        title: 'Share a ton of creative work',
      },
      'transfer-unlimited': {
        text: 'You can send (and receive) transfers with no file size limits—infinitely more than the free %{transfer_limit_free}.',
        title: 'Send transfers of any size',
      },
      'us-price-change': {
        title:
          'If you cancel your subscription and wish to re-activate it at any time, <br/> your subscription will be re-activated at our <a href="https://wetransfer.com/pricing" target="_blank">updated prices</a>.',
      },
    },
    pricing: {
      pro: {
        per_person: 'per person',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Create account',
        current_plan: 'Current plan',
        sign_up: 'Sign up',
        switch_premium: 'Switch to Premium',
        switch_pro: 'Switch to Pro',
        upgrade: 'Upgrade',
      },
      faq: {
        answers: {
          answer_1:
            'You’ll be able to get started with WeTransfer Pro or WeTransfer Premium as soon as you’ve completed your payment. We’ll also send you a confirmation email with your paid invoice attached. <br /><br />\n\nOnce you’re in, you’ll be able to send bigger transfers, start using portals, and create your very own WeTransfer page right away. If you have any previous transfers that were sent while you were on the free plan, you’ll also be able to change the expiration dates to whenever you like.',
          answer_2:
            'When you use WeTransfer, anyone can download your files—there’s no need for them to log in or sign up. They’ll have to accept our Terms of Service and we may ask them to accept cookies, but that’s it! <br /><br />\n\nIf you want to share work or collaborate in portals (WeTransfer’s latest feature), your clients and collaborators won’t need to sign up to view and select files, add comments, give approval, or download files. You’ll only need to add team members to your Pro or Premium plan if you want people to be able to add reviews and create portals with you.',
          answer_3:
            'With a Pro or Premium plan, you can create your own WeTransfer page where anyone can send you files with the transfer size limit of your plan. That means you can get the large files you need from clients or collaborators, and they won’t need to have an account—just the URL to your page. (Though we may ask them to verify their email address to protect you from “foreign princes” who “want to send you money”).',
          answer_4:
            'First, you’ll need to sign up for WeTransfer Pro or WeTransfer Premium—you can’t add team members while you’re on the free plan. And whichever plan you choose, your team members will enjoy all the same benefits (so you can’t get Premium for yourself and have some team members on Pro, for example). Team members will be able to send and receive bigger transfers from your WeTransfer page, and manage transfers from one shared overview. <br /><br />\n\nOnce you’ve signed up for the plan that’s best for your team, you’ll be able to invite as many team members as you like from your team management settings. You can add and remove members from your team at any time while your subscription is active.',
          answer_5:
            'We accept PayPal as well as credit cards by major networks such as Visa, Mastercard, and American Express. We also support other online payment systems in some countries. <br /><br />\n\nWe don’t accept direct bank transfers because you have to sign up for a recurring yearly or monthly subscription. (We’ll email you before this happens for the first time, to give you a heads up.)',
          answer_6:
            'If you don’t have the unlimited storage with WeTransfer Premium, you’ll have to either clear up some storage space by deleting some of your sent transfers or upgrade your plan. Until you do, you won’t be able to send new transfers. <br /><br />\n\nIf you’re using WeTransfer for free, all your transfers of up to 2 GB are automatically deleted after 7 days. So don’t worry, it’s not possible for you to go over your storage limit.',
          answer_6_variant_asterisk:
            'You’ll have to clear up some storage space by deleting some of your sent transfers, or upgrade your plan. Until you do, you won’t be able to send new transfers. <br /><br />\n\nIf you have Premium subscription and hit 5 TB, you can contact our support team and request more storage up to a maximum annual limit of 15 TB. <br /><br />\n\nIf you’re using WeTransfer for free, all your sent transfers of up to 2 GB are automatically deleted after 7 days. So don’t worry, it’s not possible for you to go over your storage limit.',
          answer_6_variant_limited_storage:
            'You’ll have to clear up some storage space by deleting some of your sent transfers or upgrade your plan, (unless you have a Premium subscription). Until you do, you won’t be able to send new transfers. <br /><br />\n\nIf you’re using WeTransfer for free, all your sent transfers of up to 2 GB are automatically deleted after 7 days. So don’t worry, it’s not possible for you to go over your storage limit.',
          answer_7:
            'Your subscription will automatically renew (we’ll email you before this happens for the first time), but you can cancel at any time. <br /><br />\n\nTo switch to using WeTransfer for free, all you need to do is go to your <strong>Account</strong> settings and cancel your subscription. You (and any team members you might have) will be able to continue using your Pro or Premium plan until the end of your current subscription period.',
          answer_8:
            'Millions of people around the world trust WeTransfer and our set of tools to share their ideas—with more than 2 billion files sent through our platform every month.<br /><br />\n\nTo keep your ideas safe from attack or exploitation, your files are encrypted when they are transferred (TLS) and when they are stored (AES-256). Once your files are stored, they can only be accessed using the unique links sent to the sender and recipient.',
        },
        questions: {
          question_1: 'What happens after I sign up and pay?',
          question_2: 'Do my recipients need to sign up?',
          question_3: 'Can I receive bigger transfers from anyone? ',
          question_4: 'How do I add (and remove) team members?',
          question_5: 'What payment methods can I use?',
          question_6: 'What happens if I go over my storage limit?',
          question_7: 'How do I cancel?',
          question_8: 'Can I trust WeTransfer? How safe is it?',
        },
        title: 'FAQ',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Advertising (and art)',
            custom: 'Upload your own',
            feature_1: 'Custom WeTransfer page',
            feature_2: 'Wallpaper backgrounds',
            feature_3: 'Personalized WeTransfer emails',
          },
          title: 'Show off your brand',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} storage',
            title: 'Collect by WeTransfer',
          },
          paste: {
            limited_decks:
              'Up to %{pasteDecksLimit} decks with the default Paste logo',
            title: 'Paste® by WeTransfer',
            unlimited_decks: 'Unlimited decks with your own branding',
          },
          title: 'Complete your creative toolkit',
        },
        expiry: 'Transfers expire after %{days} days',
        extra_storage: 'Extra %{storageLimit} per person',
        monthly_price: '%{price} monthly per person',
        portals: {
          features: {
            feature_1: 'Portals',
            feature_2: 'Reviews',
            feature_3: 'Client branding',
          },
          title: 'Share work for feedback and approval',
        },
        security: {
          features: {
            feature_1: 'Custom expiration dates',
            feature_2: 'Password-protected transfers',
            feature_3: 'Data encryption',
            feature_4: 'Two-factor authentication',
          },
          title: 'Secure your transfers',
        },
        storage_limit: '%{storageLimit} per person',
        teams: {
          features: {
            feature_1: 'Invite team members',
            feature_2: 'Shared transfer overview',
            feature_3: 'Shared storage',
            feature_4: 'Shared branding',
          },
          title: 'Deliver work as a team',
          subtext: {
            text: 'Only supported if you purchase a subscription from our website.',
            learn_more: 'Learn more',
          },
        },
        tooltips: {
          tooltip_1: 'All transfers you send count towards your storage',
          tooltip_10:
            'You can send and store files securely with TLS and AES-256 encryption',
          tooltip_11: 'Track downloads and manage transfers together',
          tooltip_12:
            'Show off your (team) work with branded wallpapers and emails',
          tooltip_13:
            'Paste is a presentation tool that designs decks for you with responsive colors, alignment, and layout',
          tooltip_14:
            'Collect lets you save and organize images, videos, music, and links across devices',
          tooltip_2:
            'People can download your files without having to log in or sign up',
          tooltip_3: 'Keep track of who has (or hasn’t) downloaded your files',
          tooltip_4: 'Organize your work for every client and project',
          tooltip_5:
            'Invite clients to view and select files, add comments, and give approval—without having to download a thing',
          tooltip_6:
            'Add a logo and title to customize your portals for every client',
          tooltip_7:
            'Your WeTransfer page is where people download your files and can send you transfers with the size limit of your plan',
          tooltip_8:
            'Wallpapers are the videos and images you see in the background when you’re sending and receiving files on wetransfer.com',
          tooltip_9:
            'Wow, we thought nobody would actually read these—you proved us wrong. Congrats! Screenshots may or may not get retweeted by @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Transfer size limit',
            feature_2: 'Storage',
            feature_3: 'Downloads with no account',
            feature_4: 'Track downloads',
            feature_5: 'iOS app',
          },
          title: 'Send big files',
        },
        unlimited: 'Unlimited',
        yearly_price: '%{price} yearly per person',
      },
      header: {
        subtitle:
          'Whether you’re sending big files for fun or delivering work for clients—keep creative projects moving forward with WeTransfer.',
        title: {
          english_1: 'You’ve got the ideas,',
          english_2: 'we’ve got the plans',
          general: 'Plans & pricing',
        },
      },
      plans: {
        billing: {
          discount: 'Save %{percentage} (ooh yeah)',
          discount_up_to: 'Save up to %{percentage} (ooh yeah)',
          discount_up_to_short: 'Save up to %{percentage}',
          monthly: 'Monthly billing',
          yearly: 'Yearly billing',
        },
        free: {
          subtitle: 'Send files once in a while',
          title: 'Free',
          usp: {
            feature_1: 'Send up to %{transferLimit}',
            feature_2: 'No need to verify transfers',
          },
        },
        premium: {
          subtitle: 'Share work with no limits',
          title: 'Premium',
          usp: {
            feature_1: 'No size limit on transfers',
            feature_2: 'Unlimited storage',
            feature_2_subtitle:
              '*The initial limit is %{storageLimit}, with the option to add extra storage on request. A maximum annual limit of %{annualStorageLimit} applies. Please check our <a href="/legal/terms" data-route-type="premium" target="_blank">Terms of Service</a> for more information.',
            feature_3: 'Unlimited portals and reviews',
          },
        },
        pro: {
          subtitle: 'Send really big files regularly',
          title: 'Pro',
          usp: {
            feature_1: 'Send and receive up to %{transferLimit}',
            feature_2: '%{storageLimit} storage per person',
            feature_3: '%{portalsLimit} portal, unlimited reviews',
          },
        },
        tagline: {
          free: 'no money, no problem',
          monthly: 'monthly per person',
          yearly: 'yearly per person',
          per_person_monthly: 'per person, billed monthly',
          per_person_yearly: 'per person, billed yearly',
          tax_included: 'tax included',
        },
        title: 'Choose your plan',
        banner_text: 'Save %{discount_amount} / month by',
        banner_button_text: 'paying yearly',
        month: 'month',
      },
      skip_link: 'Jump to more features',
    },
    pro_classic: {
      hero: {
        cta_1: 'Learn more',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'You’ve got the ideas, we’ve got the plans',
      },
      cta: 'I just want to send files',
      free_panel: {
        cta: 'Sign up',
      },
      plan: {
        free: {
          feature_1: 'Send up to <strong>%{transfer_limit}</strong>',
          feature_2: 'No need to verify transfers',
          subtitle_new: 'For casual file-senders',
          title: 'Free',
        },
        pro: {
          feature_1:
            'Send and receive up to <strong>%{transfer_limit}</strong>',
          feature_2: 'Decide when transfers expire',
          feature_5: '1 TB storage per person',
          subtitle_new: 'For professionals and teams',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Sign up now',
          descripttion: 'Keep track of transfers',
          feature_1: 'Send up to 2 GB',
          feature_2: 'Receive transfers in one overview',
          title: 'Free',
        },
        pro: {
          cta: 'Learn more',
          descripttion: 'Get the best of WeTransfer',
          feature_1: 'Send and receive up to %{transfer_size}',
          feature_2: '%{storage_size} transfer storage per person',
          feature_3: 'Send transfers with custom settings',
          title: 'Pro',
        },
        title: "Don't let transfers get lost in your inbox.",
      },
      title: 'Make the most of the new WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Invite team',
        pagename: 'Invite team',
      },
      manage: {
        cta: 'Manage team',
      },
      members:
        'You have %{amountOfMembers} team members. <a href="%{href}">%{cta}</a>',
      no_members: 'It\'s just you for now! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Team settings',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Team up and transfer together',
        context:
          'Send and receive transfers as a team with shared storage, branding, and access to each other’s transfers.',
        invite_team: 'Invite team',
        dismiss: 'Maybe later',
      },
      feature_highlight: {
        free_context:
          'You can now manage sent and received transfers in one simple overview. Know the minute files are downloaded. Resend, forward, or download your transfers with a click. That easy',
        free_subtitle: 'All your transfers in one place',
        paste_collect_link:
          'Go to <a href="%{pasteUrl}" rel="external">%{pasteName}</a> or <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'You can now send transfers of any size, and create your own <b>WeTransfer page</b> to customize what people see when they download your files. Ready to choose your URL and wallpapers?',
        premium_cta: 'Create page',
        premium_dismiss: 'Maybe later',
        premium_subtitle: 'Set up your WeTransfer page',
        premium_team_context:
          'You can now send and receive transfers of any size from your team’s <b>custom WeTransfer page</b>.',
        pro_context:
          'You can now send up to %{transfer_limit} in one go, and create your own <b>WeTransfer page</b> to customize what people see when they download your files. Ready to choose your URL and wallpapers?',
        pro_team_context:
          'You can now send and receive %{transfer_limit} transfers from your team’s <b>custom WeTransfer page</b>.',
        send_cta: 'Go to send files',
        team_subtitle: 'Deliver creative work as a team',
      },
      marketing: {
        context:
          'Now that we know a bit about you, we’d love to let you know a bit about us. Want in on stories about creativity and the latest WeTransfer news?',
        image_alt_text:
          'Example email content, including new product features, industry reports, and WePresent articles that tell stories about creativity.',
        opt_in: 'Yes please',
        opt_out: 'No thanks',
        unsubscribe: 'You can always unsubscribe later—no hard feelings.',
      },
      welcome: {
        context: 'Getting to know you better helps us improve our service.',
        cta: 'Continue',
        dismiss: 'Skip',
        dropdown_options: {
          architecture: 'Architecture / Construction',
          data: 'Data / Finance / Legal',
          design: 'Design / Illustration',
          education: 'Education / Training',
          marketing: 'Marketing / PR',
          music: 'Music / Sound',
          other: 'Other (and proud of it)',
          photography: 'Photography',
          product: 'Product / Software',
          sales: 'Sales / Client relations',
          video: 'Video / Animation',
        },
        free_tier_title: 'Welcome to WeTransfer, %{name}!',
        placeholder: "Hmm, let's see...",
        question: 'First, which field are you in?',
        team_title: 'You’re in the team, %{name}!',
        tier_title: 'Welcome to WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Let WeTransfer use data you share to show you tailored ads on and off our websites.',
          tooltip_anchor: 'What does this mean?',
          tooltip: {
            title: 'How is WeTransfer using my data?',
            p1: 'We use your email address to show you (and others like you) WeTransfer ads on websites you visit, such as social media.',
            p2: 'We also use your field of work to give you a better experience on our websites.',
            p3: 'The data you choose to share with us remains secure at all times.',
            button: 'Got it',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Add others to your workspace',
      workspace: 'Workspace',
      manage_workspace: 'Manage Workspace',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, something went wrong - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    complete_payment_exception:
      'Hmm, something went wrong - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    retrieve_checkout_exception:
      'Hmm, something went wrong - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    source_id_error:
      "Sorry, we couldn't process this request — please try again",
    three_d_secure: "We currently don't support 3D Secure cards.",
    generic_error:
      'Hmm, something went wrong - please try again or contact us through our help center',
    invalid_file_error:
      'This file is too big, or not a png or jpg format - try a different image',
    something_went_wrong:
      'Hmm, something went wrong - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    signin_no_data_exception:
      'Hmm, something went wrong - please check your username and password and try again',
    signin_exception: "Sorry, we couldn't sign you in – please try again",
    signout_exception:
      "Hmm, it appears we couldn't sign you out. Weird. Please refresh this page to check if you're still signed in.",
    signup_account_error:
      'Hmm, something went wrong during sign-up – please check your details and try again',
    retrieve_account_exception:
      'Hmm, something went wrong. We hate to ask, but please try again?',
    update_account_error:
      "Sorry, we couldn't update your account details. Could you try again?",
    retrieve_subscription_exception:
      "We couldn't find your payment details - please try again",
    update_subscription_exception:
      'We couldn\'t update your payment details - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    autorenewal_not_supported: 'Auto-renewal is not supported for this account',
    email_background_upload_validation_error:
      'This file is too big, or not a png or jpg format - try a different image',
    email_background_upload_validation_error_videos:
      'This file is too big, or not a png or jpg format - try a different image',
    update_password_exception:
      "Sorry, we couldn't update your password – please try again",
    retrieve_device_exception:
      "We couldn't find any connected devices. Not one! Please try again.",
    remove_device_exception: 'We could not remove this device',
    renew_subscription_exception:
      "We couldn't renew your account right now – please try again later",
    invoices_retrieve_exception:
      "We couldn't find your receipts – please try again",
    invoice_download_exception:
      "We couldn't download this receipt – please try again",
    image_not_valid: 'Hmm, it looks like this image cannot be uploaded',
    update_profile_error:
      "Hmm, we couldn't update your profile – please try again",
    retrieve_profile_exception:
      "We couldn't find your profile settings – please try again",
    s3_exception:
      'Hmm, something went wrong during your upload – please try again',
    file_size_limit_reached:
      "Bigger isn't always better – please upload an image 3MB or smaller",
    retrieve_transferlist_exception: 'We could not find your list of transfers',
    retrieve_transfer_exception: 'We could not find your transfer details',
    delete_transfer_exception: 'We could not delete this transfer',
    delete_transfers_exception: 'We could not delete these transfers',
    update_expiry_exception: 'We could not update this expiration date',
    add_contact_exception: 'We could not add this contact',
    complete_last_order_exception: "We couldn't complete your order",
    edit_contact_exception: 'We could not update this contact',
    remove_contact_exception: 'We could not delete this contact',
    request_password_reset_exception:
      "Sorry, we couldn't process this reset request — please try again",
    request_password_reset_no_user:
      "We don't recognize this email address - please double-check and try again",
    reset_password_error:
      'Something went wrong while resetting your password — please try again',
    reset_password_exception:
      "Sorry, we couldn't reset your password at the moment — please try again",
    reset_password_token_invalid:
      "Hmm, this reset link didn't work — please follow the instructions we have emailed you, or start again",
    retrieve_last_order_exception: "We couldn't find your order",
    retrieve_ternot_exception:
      'Hmm, we are having trouble finding your transfer – please try again',
    signin_invalid_credentials:
      "This email address and password don't seem to match — please double-check and try again",
    unsubscribe_expiration_exception:
      'Something went wrong while unsubscribing you – please try again',
    unsubscribe_expiration_invalid_signature:
      "Hmm, this unsubscribe link didn't work — please try again",
    cancel_subscription_exception:
      "Looks like something went wrong and we couldn't cancel your subscription, please try again later.",
    payment_cancelled:
      'Hmm, something went wrong - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    profile_picture_upload_validation_error:
      'This file is too big, or not a png or jpg format - try a different image',
    reactivate_subscription_exception: 'Something went wrong, please try again',
    retrieve_contactlist_exception: 'We could not find your list of contacts',
    source_retrieve_error:
      'Hmm, something went wrong - please try again or contact us through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>',
    token_error: 'Something went wrong. Maybe try again?',
    update_user_error: 'There was a problem updating your information',
    wallpaper_upload_validation_error:
      'This file is too big, or not a png or jpg format - try a different image',
    wallpaper_upload_validation_error_videos:
      'Oops, looks like your video doesn’t fit our requirements — have another go',
    declined_contact_bank_error:
      "Sorry, we couldn't process this payment — please contact your bank",
    invalid_password: 'Password not recognized',
    otp_token_invalid: 'Uh-oh, that code is wrong or expired',
    projects_load_exception: "We currently can't load your projects",
    update_information_throttle:
      'There was a problem updating your information. Take a %{throttle_time} break before you try again.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
    price_general_error_transfer_details:
      'The price could not be updated, please try again',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Products',
        plans_and_pricing: 'Plans and pricing',
        pricing: 'Pricing',
        pro_and_premium: 'WeTransfer Pro and Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Advertise',
        upgrade: 'Upgrade',
      },
      name_1_2019: 'Company',
      name: 'Company',
    },
    accessibility: {
      aria_label: 'Main',
    },
    home: {
      name: 'Home',
    },
    help: {
      name: 'Help',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transfers',
        contacts: 'Contacts',
        profile: 'Profile',
        account: 'Account',
        received: 'Received',
        sent: 'Sent',
        teams: 'Team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Sign out',
    signin: {
      name: 'Sign in',
    },
    branding: 'Branding',
    label: {
      beta: 'Beta',
      new: 'New',
    },
    login: 'Log in',
    logout: 'Log out',
    portals: 'Portals',
    signup: 'Sign up',
    features: {
      name: 'Features',
      all: 'All features',
      file_sharing: 'For file sharing',
      collaboration: 'For collaboration',
      security: 'For data security',
      branding: 'For branding',
      fast_feedback: 'For fast feedback',
    },
    referral: 'Refer friends',
    switcher: {
      create_free_account: 'Add for free',
      just_you: 'Just you',
      team: 'Team',
      team_member_count: '%{amountOfMembers} members',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: "Hmm, you're not connected to the internet",
        begins_space:
          "We can't send files whose names begin with a space. Please rename and try again.",
        begins_stop:
          "We can't send files whose names begin with a full stop. Please rename and try again.",
        blocked: "We couldn't load WeTransfer – you appear to be blocked",
        generic: "We're sorry to say something went wrong during your transfer",
        has_blackslash:
          "We can't send files whose names include a backslash. Please rename and try again.",
        has_linebreak:
          "We can't send files whose names include a line break. Please rename and try again.",
        incorrect_recipient:
          'It looks like one of the email addresses you entered is incorrect',
        incorrect_sender:
          'It looks like there is a problem with your email address',
        io_error: 'There is an issue with your files',
        long_filename:
          "We can't send files whose names have more than 250 characters. Please rename and try again.",
        long_message: 'That message is a bit too long – please make it shorter',
        missing_default_recipient:
          'Only registered WeTransfer Pro email addresses can receive more than %{free_transfer_limit}. Refresh the page to start again.',
        no_clipboard: "It looks like you haven't copied the link",
        no_files: "It seems you haven't added any files yet!",
        no_folders:
          'You need to zip/compress your folder before we can send it',
        no_recipient:
          'We need the email address you want to send these files to',
        no_sender: "We just need your email address now and we're good to go",
        too_big:
          "Whoa there – we can't transfer more than %{upload_limit} at a time",
        too_many_recipient:
          'Oops – %{count} people is our limit. Need more? Why not use a link transfer.',
        unavailable:
          'Sorry, this transfer has been deleted and is not available any more',
        wrong_password:
          "Hmm, that password isn't right. Please try again or check with the person who sent you this transfer?",
        default_title: 'Whoops!',
        duplicate_filename:
          "We can't send multiple files with the same name. Please rename and try again.",
        firstaccept: 'You need to approve first, before sending',
        not_downloadable:
          'Hmm, something went wrong while getting your files. Please reload the page and try again.',
        recaptcha: {
          text: 'Something went wrong. Please try again!',
          title: 'Uh-oh...',
        },
        too_big_text:
          'You can’t transfer more than %{upload_limit} at a time. Send up to %{plus_limit} with Pro. ',
        too_big_title: 'Hey big sender',
        too_many_files:
          "You can't send more than %{count} files at the same time",
        too_many_recipient_text:
          'You can transfer files to up to 50 people with Pro.',
        too_many_recipient_title: "That's too many people",
        unavailable_forward:
          "Unfortunately it looks like this transfer has been deleted so it can't be forwarded",
        verify: {
          button: 'New code please!',
          text: 'Try again or request a new code. ',
          title: 'Whoops!',
        },
      },
      buttons: {
        check_out: 'Check it out!',
        help: 'Help Center',
        plus: 'Get Pro',
        get_link: 'Get link',
      },
      tips: {
        change_type:
          'Send your transfer link in an email or generate a link to share how you want',
        contacts:
          'Anyone you send files to will be automatically added to your contacts',
        expiry:
          'With WeTransfer Pro you decide when transfers expire. (You can even change the expiration date after a transfer’s been sent!)',
        free_limit:
          'Good news, you can send up to %{size} at a time. Better news, you can use the service as often as you like!',
        message: "If you'd like, add a message to go with your transfer here",
        password:
          "You can password-protect a transfer for added security. Please note we don't add the password into the email so you'll need to give it to the right people!",
        recipient_limit:
          'Add up to %{email_limit} emails or open the menu next to the transfer button to create a link',
        transfer_history: 'Your transfer is stored in your transfer overview',
        your_email:
          'Pop your own email address in here so we can let you know when your files have been downloaded',
        link_transfer: 'Did you know you can get your transfer link instead?',
        previews_receiver:
          'Images sent by Pro users can be previewed before downloading. Just click on a file to see what’s inside!',
        previews_sender:
          "Images you send can now be previewed before they're downloaded",
        vrl_text:
          'You can now have a look at your files without having to download them.',
        vrl_title: 'Preview your files',
        zip_text: "Sending a folder? We'll zip it for you",
        zip_title: 'No need to zip',
        add_display_name_tooltip:
          'Give your transfer a title so people know what your files are about. This also makes it easier to find later.',
        anonymous_sender: {
          button: 'Get a link',
          text: 'Pop in your email and we’ll let you know when your files get downloaded.\n\nYou’ll need to verify your email so we know it’s really you. Don’t want to verify every time?',
          text_locked_recipient:
            'Pop in your email and we’ll let you know when your files get downloaded.\n\nYou’ll need to verify your email so we know it’s really you.',
        },
        prefer_link: {
          button: 'Get a link',
          text: 'Don’t want to verify your email? That’s okay.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Learn more',
        previews_sender_learnmore: 'Learn more',
      },
      recipient_locked_text:
        'This page is for the owner to receive files. Log in if that’s you, or head to <a href="https://wetransfer.com">wetransfer.com</a> to send to anyone else.',
      recipient_locked_title: 'Heads up',
      title: {
        previews_receiver: 'Introducing image previews',
        previews_sender: 'Introducing image previews',
      },
    },
    download: {
      blocked: {
        link: 'Find out more',
        text: 'This transfer has been reported and can’t be downloaded',
        title: 'Transfer unavailable',
      },
      title: 'Ready when you are',
      expires: 'Transfer expires in %{relative_time}',
      expires_never: 'No expiration date',
      files: '%{count} files, %{size}',
      format: '%{files}・%{expires}',
      expand: 'more',
      download_link: 'Download link',
      files_nosize: {
        one: '%{count} file',
        other: '%{count} files',
      },
      show_all_files_mobile: 'Show all files',
      zip_information:
        'You will receive a .zip file when you download all files at once - <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">read more</a>',
      files_label: 'Files',
      message: 'Message',
      learn_more: 'learn more',
      expires_in: 'Expires in %{expiry}',
      download_all_zip: 'Download all will download all files as a .zip',
      back_to_transfer: 'Back to transfer',
      cookie_text:
        'We use cookies to give you the best experience. Fear not, we don’t sell your data to third parties. Manage your <a href="https://wetransfer.com/legal/manage-cookies" rel="external">data preferences</a>.',
    },
    preview: {
      open_grid: 'Preview',
      click_to_open: 'Click to preview',
      grid: 'Items in this transfer',
      link: 'Website',
      not_previewable: 'Preview not available',
      now_open: 'Preview open',
      open_link: 'Open link in new tab',
      open_link_short: 'Open link',
      overview: 'overview',
      reload: 'Reload',
      something_went_wrong: 'Oops, something went wrong',
      tap_to_open: 'Tap to preview',
      toobig_copy:
        'We can only preview images up to 50MB – <a href="https://wetransfer.zendesk.com/" rel="external">read more here</a>',
      toobig_title: 'Oof – this image is too big to preview',
      unsupported_copy:
        'Check out <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">this article</a> to find out which files we can preview',
      unsupported_title: 'We can’t preview this file (yet)',
      visit_website: 'Visit website',
    },
    complete_mobile: {
      email_text:
        'The transfer email has been sent – your transfer is available for %{expires}',
      link_text: 'Copy your download link:',
      email_text_no_expiry: 'An email has been sent to the receiver.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Did you know that 30% of our advertising space goes to artists?</b> By accepting our cookies, you allow us to show you a little bit of art, causes we care about, and some award-winning ads that don’t get in the way. ',
          text: 'Do you also allow cookies from our third-party advertising partners so we can personalize the ads you see? ',
          title: 'Our cookies feed culture',
        },
        subtitle:
          "<b>That's why 30% of our advertising space goes to artists.</b> By accepting our cookies, you allow us to show you a little bit of art, causes we care about, and some award-winning ads that don’t get in the way. ",
        text: 'Our website uses cookies that help it work properly, allow us to understand how you use WeTransfer, and help us improve performance. Do you also allow cookies from our third-party advertising partners so we can personalize the ads you see?',
        title: 'We believe art can move mountains',
        'title-small': 'Welcome to WeTransfer',
      },
      'button-accept': 'I accept',
      'button-accept-all': 'Accept all',
      'button-ccpa': 'Opt Out of the Sale of Personal Information',
      'button-cookies-privacy': 'Your Privacy Choices',
      'button-reject': 'No thanks',
      'button-save': 'Save',
      'button-save-and-exit': 'Save and close',
      'ccpa-banner-text':
        'We use cookies to make sure you have the best experience on our website. Fear not, we don\'t sell your data to third parties. Opt out anyway? <a href="%{href}">Manage settings</a>',
      'ccpa-body':
        'Because you’re in the US, your rights are protected by the California Consumer Privacy Act (CCPA) and you can ask us to stop selling your personal information. This doesn’t mean that we auction your personal details or private files to the highest bidder otherwise—we never have and never will! We go to great lengths to keep your digital footprint small, safe, and in your control. You can read more about what data we collect and why in <a href="%{href}">Your Privacy Choices</a>.',
      'ccpa-donotsell': 'Do not sell my personal information',
      'ccpa-header': 'Opt Out of the Sale of Personal Information',
      'ccpa-intro':
        'As a responsible tech company committed to a better internet, we don’t sell your data to third parties. But you have the right to officially opt out anyway.',
      'ccpa-variant-test-text':
        'We use cookies to make sure you have a seamless experience on our website, and to personalize the ads you see. <a href="%{href}">Manage cookies</a>',
      headline: 'Cookies and advertising',
      intro:
        'We use the money we make from our beautiful advertisements to help pay our bills. That’s how we can afford to provide our file-sharing service for free.',
      'manage-cookies': 'Manage cookies',
      'partners-consent': 'Consent',
      'partners-features': 'Features',
      'partners-headline': 'Our partners',
      'partners-text':
        '<p>Here’s an alphabetical list of the carefully selected partners we allow to measure your data so we can track and improve performance.</p>',
      'preferences-headline': 'Manage cookies ',
      'preferences-text':
        '<p>We respect your right to privacy and your choices regarding your data. We need to process some of your personal information when you’re using our tools, but we’re committed to a responsible and values-driven approach to business, tech, and our relationship with you.</p>\n<p>That’s why we go to great lengths to keep your digital footprint small, safe, and in your control.</p>\n<p>By default we only collect and process data when strictly necessary. However, if you’d like to support our service and keep WeTransfer free, please allow us to share information with our advertising partners.</p>',
      'preferences-text-allow-cookies':
        'Allow cookies so we and/or our partners can:<br><br>',
      'purpose-description-first-intro':
        'To promote products on and outside of our website and apps, WeTransfer can: ',
      'purpose-description-first-list':
        '<ul><li>Collect information about how you interact with our website(s), such as click behaviour and visited pages, and (when possible) combine this information with data that we have saved about you, such as your account email address</li><li>Use the information we collect to provide you with offers and promotions via email; on our own website(s) or apps; and on websites or apps of third parties. For example, we might promote one of our other products to you when you use WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'To promote products on and outside of our website and apps, our partners can: ',
      'purpose-description-second-list':
        '<ul><li>Collect information about how you interact with our website(s), such as click behaviour and visited pages, and (when possible) combine this information with data they have saved about you</li><li>Use the information they collect to provide you with offers and promotions via email; on their own website(s) or apps; and on websites or apps of third parties they work with.</li></ul>',
      'purpose-title':
        'Promote products on and outside of our website and apps',
      'switch-by-partners': 'By partners',
      'switch-by-we-transfer': 'By WeTransfer',
      text: '<p>Our website uses <a href="%{href}">cookies</a> that help it to function, allow us to analyze how you interact with it, and help us to improve performance.</p>\n<p>Do you also want to allow cookies from our advertising partners so we can personalize the ads you see, as well as promote products by WeTransfer and our partners on and outside our websites and apps?</p>',
      'text-panel':
        '<p>Our website uses cookies that help it to function, allow us to analyze how you interact with it, and help us to improve performance.</p>\n<p>Do you also want to allow cookies from our advertising partners so we can personalize the ads you see, as well as promote products by WeTransfer and our partners on and outside our websites and apps?</p>',
      'tos-experiment': {
        'cookie-intro':
          'The simplest way to send big files while discovering amazing art and award-winning ads.',
        'cookie-text':
          'Our website uses cookies that help it function, allow us to analyze how you interact with it, and help us improve performance. \nBy accepting our cookies, you allow us to show you personalized ads. Did we say the word cookies enough? (Cookie.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Our mission is to make the world more beautiful through award-winning ads that don’t get in the way and help us contribute to the restoration of sea forests.',
          title: 'Our cookies protect the planet',
        },
        subtitle:
          'By accepting our cookies, you directly help us to expand our pledge to the planet. This year alone, WeTransfer has committed to planting over 175,000 trees, and we’re just getting started. You’ll have a positive impact by simply experiencing our award-winning ads. ',
        text: 'Our website uses cookies to improve performance, service, and to better understand your needs. By accepting our third-party cookies, we and our partners are able to offer you more relevant advertising on and outside of our website(s) and apps.',
        title: 'Transfer ideas. <b>Transform the world.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Unlock Collect Pro',
      title: 'Save and share inspiration on the go',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Tell me more',
      title: 'Paste® Pro and Collect Pro now included in your subscription',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Unlock Paste® Pro',
      title: 'Turn big ideas into beautiful presentation decks',
    },
    terms_conditions: {
      experiment: {
        text: 'To continue, please agree to our <a href="/legal/terms" data-route-type="plus">Terms of Service</a>.',
        title: "You’re <span class='tc-title-exp'>almost</span> there",
        ustitle:
          "Welcome to the simplest way to <span class='tc-title-exp'>send big files.</span>",
      },
      title: 'First up...',
      text: 'To continue, please agree to our <a href="/legal/terms" data-route-type="plus">Terms of Service</a> and <a href="/legal/privacy" data-route-type="plus">Cookie Policy</a>. We use cookies for functional and analytical purposes and third party cookies for advertising purposes.',
      language: 'Your language is set to',
      button: 'I agree',
    },
    upsell_pricing: {
      text: 'Compare plans',
      title: 'Want to send bigger transfers?',
      receiving: {
        title: 'Want to get the most out of WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Send and receive %{transfer_limit} transfers with one <strong>shared overview</strong>',
      card2:
        'Deliver work from your team’s <strong>custom WeTransfer page</strong>',
      card3:
        'Collaborate on decks in <strong>Paste®</strong> and boards in <strong>Collect</strong>',
      cta: 'Let’s get started',
      headline: 'You’re in the team, <strong>%{first_name}!</strong>',
      'opt-in':
        'I want in on stories about creativity and the latest WeTransfer news',
    },
    form: {
      num_files: {
        one: '%{count} file added · %{remaining} remaining',
        other: '%{count} files added · %{remaining} remaining',
      },
      add_files: 'Upload files',
      more_files: 'Add more files',
      available_space: 'Add up to %{size}',
      message: 'Message',
      from: 'Your email',
      to: 'Email to',
      other_recipients: {
        one: '+%{count} other',
        other: '+%{count} others',
      },
      reset_forward: 'Cancel this forward',
      drop_files: 'or drag and drop',
      files_count: {
        one: '%{count} file added · %{fileSize} in total',
        other: '%{count} files added · %{fileSize} in total',
      },
      select_folder: 'Or select a folder',
    },
    progress: {
      title: 'Transferring...',
      title_finalizing_one: 'Finalizing...',
      title_finalizing_two: 'Almost there...',
      title_finalizing_three: 'One more moment...',
      title_finalizing_four: 'Wrapping up...',
      subtitle_finalizing:
        'Do not close this window until we complete the transfer',
      title_cancel: 'Cancel this transfer?',
      uploaded: '%{sent} of %{total} uploaded',
      remaining: {
        minutes: {
          zero: 'Less than 1 minute remaining',
          one: 'About 1 minute remaining',
          other: 'About %{count} minutes remaining',
        },
        hours: {
          one: 'About 1 hour remaining',
          other: 'About %{count} hours remaining',
        },
      },
      document_title: '%{percentage}% - Transferring...',
      meta: {
        email: {
          one_file_one_recipient:
            'Sending %{filesCount} file to %{recipientsCount} person',
          one_file_other_recipients:
            'Sending %{filesCount} file to %{recipientsCount} people',
          other_files_one_recipient:
            'Sending %{filesCount} files to %{recipientsCount} person',
          other_files_other_recipients:
            'Sending %{filesCount} files to %{recipientsCount} people',
        },
        link: {
          one: 'Sending %{count} file',
          other: 'Sending %{count} files',
        },
      },
    },
    complete_link: {
      title: 'You’re done!',
      text: 'Copy your download link or <a href="/transfer/progress">see what\'s inside</a>',
      text_copied: 'The link has been copied to your clipboard',
      text_manual_copy:
        'Your link is ready\nPress %{shortcut} to copy it to your clipboard',
      document_title: 'Done!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Your transfer has been forwarded',
    },
    complete_email: {
      title: 'You’re done!',
      text: 'The transfer email has been sent – your transfer is available for %{expires}. <a href="/transfer/progress">See what\'s inside</a>',
      text_no_expiry:
        'The transfer email has been sent. <a href="/transfer/progress">See what\'s inside</a>',
      document_title: 'Sent!',
      text_no_details:
        'The transfer email has been sent – your transfer is available for %{expires}.',
      team_discovery_title: 'Transfer sent!',
      team_discovery_text:
        'Your transfer will be available for download for %{expires}',
    },
    failed: {
      title: 'Hmm, something went wrong',
      text: "So it looks like your transfer didn't work – please give it another go",
    },
    pending: {
      title: "We're nearly ready...",
      subtitle: 'Preparing...',
    },
    downloading: {
      title: 'Getting your files...',
      text: "We're just preparing your download",
    },
    downloaded: {
      title: 'Your download has started',
      text: "Once it's done, the files will be on your computer (often in the downloads folder).",
      download_links:
        'Just be aware the links in this Board won’t show up – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">read more</a>.',
    },
    expired: {
      title: 'Transfer expired',
      text: 'Sorry, this transfer has expired and is not available any more',
    },
    password: {
      title: 'Enter password',
      text: 'You need a password to download this transfer',
    },
    options: {
      transfer_type: 'Send as',
      password: 'Password',
      password_placeholder: 'Set password',
      expiry: 'Expires after',
      expire_in: {
        '1w': '1 week',
        '2w': '2 weeks',
        '1m': '4 weeks',
        never: 'Never',
        '14d': '2 weeks',
        '28d': '4 weeks',
        '365d': '1 year',
        '7d': '1 week',
        '90d': '3 months',
      },
      email: 'email',
      link: 'link',
      email_transfer: 'Send email transfer',
      transfer_link: 'Get transfer link',
      appearence: 'Appearence',
      set_custom_wallpaper: 'Set custom wallpaper',
    },
    buttons: {
      transfer: 'Transfer',
      forward: 'Forward',
      new_transfer: 'Send a file?',
      cancel: 'Cancel',
      cancel_no: 'No',
      cancel_yes: 'Yes',
      copy_link: 'Copy link',
      ok: 'Ok',
      done: 'Send another?',
      team_discovery_done: 'Send new transfer',
      retry: 'Try again',
      continue: 'Continue',
      download: 'Download',
      download_all: 'Download all',
      back_to_home: 'Back to home',
      cleanup: 'Review transfers ',
      download_all_files: 'Download all files',
      help: 'Help Center',
      payment: 'Renew now',
      complete_order: 'Go to checkout',
      download_all_experiment: 'Download all as a .zip',
      download_experiment: 'Download file',
      download_file: 'Download file',
      download_zip: 'Download all as a .zip',
      get_link: 'Get Link',
      go_to_transfer: 'Go to transfer',
      openinapp: 'Save with Wetransfer app',
      openinapp_experiment: 'Save with Wetransfer app',
      openincollectapp: 'Save with Collect app',
      get_a_link: 'Get a link',
    },
    account_expired: {
      text: 'Renew now to keep enjoying all the benefits of your Pro account, or <a href="#signout">sign out</a> to use our regular service',
      title: 'Your Pro account has expired',
    },
    invalid: {
      text: "We couldn't find your files",
      title: 'Oops...',
      link: 'Find out more',
    },
    outdated_browser: {
      text: 'WeTransfer supports a whole range of web browsers, but it looks like this one is too old — please update your browser',
      title: 'Your web browser is outdated',
    },
    spam: {
      text: 'This transfer was reported as spam and has been deleted',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Increase limit',
      limit: 'Up to %{limit} free',
      remaining: '%{remaining} remaining',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Get WeTransfer Pro',
      title: 'Password-protect transfers for extra peace of mind',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Get WeTransfer Pro',
      title: 'A smarter, simpler way to manage your transfers',
    },
    upsell_one: {
      bubble: {
        button: 'Get Pro',
        text: 'Password-protect your transfers and choose custom expiration dates',
        title: 'Transfer upgrade?',
        text_experiment:
          'You can set passwords and expiration dates on your transfers with Pro.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer on Facebook',
      title: 'Join the WeTransfer community on Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Get WeTransfer Pro',
      title: 'Personalize your WeTransfer page',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Get WeTransfer Pro',
      title: 'Go bigger, better, stronger, faster',
    },
    account_inactive: {
      text: 'Complete your registration to get started with Pro',
      title: 'Your account is\nnot active yet',
      tiers: {
        text: 'Complete your payment to get started with %{plan}.',
        title: 'Your subscription is not active yet',
      },
    },
    add_items: {
      files: 'Files',
      folders: 'Folders',
    },
    complete: {
      open_panel: '<a href="/transfer/progress">See what\'s inside</a>',
    },
    details: {
      button: {
        dismiss: 'Dismiss',
      },
    },
    download_preview: 'Download file',
    error: {
      expired: {
        link: 'Reach out to our support team.',
        text: 'Dang, looks like your transfer has already expired.\nDoesn’t seem right?',
        title: 'Transfer expired',
      },
    },
    item: {
      details: {
        folder: 'Folder',
      },
    },
    items: {
      zero: 'empty',
      one: '%{count} item',
      other: '%{count} items',
    },
    mobile: {
      button: {
        back: 'Back',
        cancel: 'Start over',
        next: 'Next',
      },
      email: {
        title: 'Add email addresses',
      },
      message: {
        placeholder: 'Add a message to your transfer',
        title: 'Message',
      },
      options: {
        email: 'Send an email',
        'email-description':
          'Send your transfer with a simple email and we’ll let you know when it’s been downloaded.',
        link: 'Get a link',
        'link-description':
          'Turn your files into a link and share it however you like.',
      },
    },
    recaptcha: {
      button: 'I’m 100% human',
      text: 'We just need to check you’re not a robot (no offense)',
      title: 'You’re nearly done!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Help us out',
      title: 'Can we ask you something about the way you work?',
    },
    'verification-code': 'Verification Code',
    verify: {
      button: 'Start Transfer',
      text: 'Check your inbox for a verification code and pop it in below',
      title: 'You’ve got mail',
      'verification-code': 'Verification code',
    },
    'account-verification-failed': {
      body: 'We’re having some trouble confirming your email. Send a new link to have another go.',
      cta: 'Send a new link?',
      title: 'Something went wrong',
    },
    'cookie-banner': {
      'button-accept': 'Okay',
      'button-decline': 'Nope',
      text: 'We use <a href="%{href}">cookies</a> that help the website function, allow us to analyze how our users interact with it, and help us improve it. Do you also want to allow third party cookies so you get personalized advertising?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'We use analytical cookies to help us understand how you use WeTransfer. They allow us to A/B test new features, ensure that everything is working as it should, and stop bots and malicious behavior like spam. These cookies may include third-party cookies which process personal information. ',
        title: 'Analytical cookies',
      },
      clear: {
        'clear-all-cookies': 'Clear all cookies',
        description:
          'You can remove all your data from our cookies. For permanent anonymity requests, please contact <a href="mailto:support@wetransfer.com">contact our support team.</a>',
        title: 'Clear cookies',
        warning:
          'You will be signed out of WeTransfer after clearing cookies. This won’t affect transfers on your account.',
      },
      functional: {
        description:
          'We use functional cookies to create a seamless experience for you on WeTransfer. They are required to use our Service.',
        title: 'Functional cookies',
      },
      'not-yet-set':
        'It seems like you haven’t given us your cookie preference yet. Please close this panel and set your preference, you can always change it here afterwards.',
      'save-and-reload': 'Save settings',
      tracking: {
        description:
          'We use advertising cookies on our Service to help us measure the success of our commercial, editorial, and promotional efforts. Advertising cookies are not placed on pages that provide information on our brand and products. Advertising cookies allow us to record, for example, that you have clicked on a particular advertisement. If cookies placed by third parties are also placed on other domains and websites, advertisers may be able to follow your behavior across the internet, but WeTransfer cannot access or use any of this personal information that may be collected. As such, we refer you to the privacy policies of the relevant third parties.',
        title: 'Advertising cookies',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Oops, something went wrong',
        'error-email-exists': 'Oops, looks like this email is already taken',
        'throttle-error':
          'Whoa, we’ve sent you too many emails now. Please wait %{throttle_time} before requesting a new code.',
      },
      back: 'Back to code verification',
      body: 'Have we got this right? This is the email that you’re using on WeTransfer.',
      email: 'Email',
      error: 'Oops, something went wrong',
      'error-email-exists': 'Oops, looks like this email is already taken',
      submit: 'Resend',
      'throttle-error':
        'Sorry, you’ve tried too many times. Please start your transfer again.',
      'throttle-error-action': 'Start again',
      'throttle-error-link':
        'Whoa, we’ve sent you too many emails now. Please wait %{throttle_time} before requesting a new email.',
      title: 'Check your email',
    },
    'email-verification-success': {
      body: 'Now people can trust that your transfers have really been sent by you.',
      free_signup: 'Create free account',
      onboarding_body:
        'High five, you’re in! Ready to choose your own URL and wallpapers?',
      onboarding_title: 'Welcome to<br/>WeTransfer Pro!',
      send_files: 'Send files',
      start_onboarding: 'Let’s go',
      title: 'Your account has been verified!',
      upsell: 'Don’t want to verify your email every time?',
      verified_sender_tooltip:
        'Your email is verified, which lets people trust that transfers have been sent by you. To change this email, update your <a href="%{href}">personal details</a>.',
      verified_sender_tooltip_icon:
        'You’ve verified your email address. This lets people trust that transfers have been sent by you.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Uh-oh, that code is wrong or expired. Codes are only active for %{expiry_time} after they’ve been sent.',
        'error-expiry-time-action': 'Get new code',
        'throttle-error':
          'You’ve entered a wrong or expired code too many times. Please wait %{throttle_time} before requesting a new code.',
      },
      back: 'Go back',
      body: 'We\'ve sent a verification code to <strong title="%{account_email}">%{account_email}</strong> to make sure you\'re really you. (remember to check your Spam folder).',
      body_link:
        'Just one quick check to make sure you’re really you.<br/><br/>We’ve sent a verification link to <strong title="%{account_email}">%{account_email}</strong> (if you can’t find it, check your Spam).',
      error: 'Uh-oh, that code is wrong or expired',
      'error-expiry-time':
        'Uh-oh, that code is wrong or expired. Codes are only active for %{expiry_time} after they’ve been sent.',
      'error-expiry-time-action': 'Get new code',
      resend: "Didn't receive an email?",
      submit: 'Verify',
      'throttle-error':
        'Sorry, you’ve tried too many times. Please start your transfer again.',
      'throttle-error-action': 'Start again',
      title: 'Confirm your email',
      'verification-code': 'Enter verification code',
    },
    'force-account-verification': {
      body: 'We’ll email you a link to confirm the email address you’re using on WeTransfer.',
      cta: 'Send email',
    },
    'marketing-email-prompt': {
      body: 'One last thing - would you like to receive WeTransfer news and product updates?',
      skip: 'No thanks',
      subscribe: 'Yes, stay in touch',
      title: "You're verified!",
    },
    'terms_conditions-no-cookies': {
      text: 'To continue, please agree to our <a href="/legal/terms?from_home" data-route-type="plus">Terms of Service</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Get your files in the WeTransfer app',
      ios_banner_prompt_send: 'Send files quick and easy',
      tnc_subtitle: 'The simplest way to send big files',
    },
  },
  account: {
    legend: {
      plan: 'Plan',
      save: 'save %{amount}%',
      subscription: 'Subscription',
      summary: 'Order summary',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Why we’re asking you to confirm your email',
    workspace: {
      default_workspace: '%{name}’s workspace',
      your_workspace: 'Your workspace',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Your Privacy Choices',
        subtitle: 'Manage your data',
        p1: 'We always want to give you the best experience, even when it comes to our advertising.',
        p2: "We'd like to use data you choose to share, like your email address, to understand what kind of content you like best and use that to show you (and others like you) WeTransfer ads that are most tailored to your needs.",
        p3: 'Everything you create and share with WeTransfer remains private to you--we do not read or use it for advertising purposes.',
        p4: 'If you decide to share with us, this information will always remain secure.',
        control_label:
          'Let WeTransfer use data you share, such as your email and field of work, to tailor the ads you see on and off our websites.',
      },
      vertical_nav: {
        terms_of_service: 'Terms of Service',
        privacy_and_cookie_statement: 'Privacy & Cookie Statement',
        your_privacy_choices: 'Your Privacy Choices',
        notice_and_takedown_policy: 'Notice and Takedown Policy',
        responsible_disclosure_policy: 'Responsible Disclosure Policy',
        advertising_terms_and_conditions: 'Advertising Terms & Conditions',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Close and go to send files',
  },
  account_start_screen: {
    'collect-description':
      'Save all your inspiration in one place, whether you’re on your phone, laptop, or tablet.',
    'collect-title': 'Go to Collect',
    'paste-description':
      'Make beautiful slides in seconds with presentation decks that design themselves.',
    'paste-title': 'Go to Paste®',
    title: 'Three tools. One account. Endless possibilities.',
    'transfer-cta': 'Let’s do this',
    'transfer-description':
      'Make a great impression every time someone downloads your files. Ready to choose your own URL and wallpapers?',
    'transfer-title': 'Set up your own WeTransfer page',
  },
  account_welcome_screen: {
    'pro-title': 'Welcome to WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Yes, please',
    'accept-short': 'Okay',
    body_1:
      'Want in on stories about creativity and the latest WeTransfer news?',
    body_2: '(You can always unsubscribe later.)',
    decline: 'No, thanks',
    'decline-short': 'No thanks',
    title: 'Welcome to WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Accept cookies',
      deny: 'Deny cookies',
      manage: 'Manage cookies',
    },
    description:
      'We use regular cookies and analytical cookies to ensure a great experience, and third-party cookies for advertising purposes.',
    heading: 'Discover the simplest way to send big files',
    snippet: 'Welcome to WeTransfer',
  },
  dropzone: {
    pro: {
      title: "<span>Drop</span> it<br>like it's hot",
    },
    title: 'Drop it like it’s hot',
    text: 'Upload files or folders by dropping them in this window',
  },
  form: {
    account: {
      billing_address: 'Billing address',
      billing_cta: 'Go to payment',
      billing_title: 'Billing information',
      legend: {
        details: 'Your billing information',
        coupon_code: 'Add a discount code',
        free_plus: 'Get your free WeTransfer account',
      },
      label: {
        year_label: 'Annual',
        year_sublabel: 'Best value: save %{discount_rate}%!',
        month_label: 'Monthly',
        month_sublabel: 'Recurring billing',
        email: 'Email address',
        not_required: '(optional)',
        current_password: 'Current password',
        new_password: 'New password',
        repeat_new_password: 'Confirm new password',
        password: 'Password',
        password_confirm: 'Confirm password',
        full_name: 'Full name',
        company: 'Company',
        street_and_number: 'Address',
        city: 'City',
        zipcode: 'Zip code',
        country_code: 'Country',
        vat_number: 'VAT',
        coupon_code: 'Discount code',
        family_name: 'Surname',
        given_name: 'First name',
        state_code: 'State',
      },
      description: {
        password: 'Select a password that contains at least 6 characters',
        vat_number:
          "We charge companies located in the Netherlands 21% VAT. If your business is located anywhere else in the EU, please enter your company details and European tax ID to remove VAT from your bill.\n\nIf your business is located outside the EU VAT-region, we'll still need your billing information, but we won't charge VAT.",
      },
      error: {
        email: {
          blank: 'Please enter your email address',
          invalid: 'Please enter a valid email address',
          taken: 'This email address is already in use',
          taken_login:
            'Looks like you already have an account. <a class="form-notification__message-link" href="%{login_url}">Log in?</a>',
        },
        current_password: {
          invalid: 'Password not recognized',
          blank: 'Please enter your current password',
        },
        password: {
          blank: 'Please enter your new password',
          too_short: 'Your password must contain at least 6 characters',
        },
        password_confirm: {
          blank: 'Please confirm your new password',
          confirm: "These passwords don't seem to match",
        },
        full_name: {
          blank: 'Please enter your full name',
          too_short: 'Oops, your name needs at least 3 characters (sorry JT)',
        },
        street_and_number: {
          blank: 'Please enter your address',
        },
        city: {
          blank: 'Please enter your city',
        },
        zipcode: {
          blank: 'Please enter your zip code',
        },
        country_code: {
          inclusion: 'Check your spelling, or try a different country',
          blank: 'Please enter your country',
        },
        state_code: {
          inclusion: 'Is that a state?',
        },
        vat_number: {
          vat_number: 'Please enter a valid VAT number',
        },
        terms_of_service: {
          accepted: 'Please accept our Terms of Service to continue',
        },
        no_results: 'Check your spelling, or try a different country',
        convert: {
          expired:
            "Sorry, this transfer has already expired and can't now be saved. Did you know WeTransfer Pro lets you keep transfers for as long as you want? Find out more here.",
        },
        coupon_code: {
          coupon_code: 'Please enter a valid discount code',
        },
        no_state_results: 'Is that a state?',
      },
      complete_order: 'Complete your order',
      terms_conditions:
        'I agree to the <a href="/legal/terms" %{options}>Terms of Service</a> and I have read the <a href="/legal/privacy" %{options}>Privacy & Cookie Statement</a>',
      signup_for_plus: 'Sign up for WeTransfer Pro',
      account_cta: 'Let’s go',
      signup_for_account: 'Sign up for a WeTransfer account',
      'email-verification-not-verified-link':
        'Please verify your email address. Check the email we’ve sent you or <button type="button" class="button button--link">request a new one</button>.',
      'email-verification-resend': {
        error: 'Oops, something went wrong',
        info: 'New code sent! Please check your inbox',
        info_link: 'New email sent! Please check your inbox',
        'throttle-error':
          'Whoa, we’ve sent you too many emails now. Please wait %{throttle_time} before requesting a new code.',
      },
      'force-account-verification': {
        message:
          'Please verify your email address to let us know you’re really you.',
      },
      marketing_opt_in:
        'I would like to receive WeTransfer news and product updates',
      sso: {
        header: 'Personal details',
        password_reset: {
          button: 'Send email',
          instructions:
            'Need a little (password) change? We got you. Just hit the button below and we’ll send an email to <span>%{email}</span> with a link to change your password.',
          success: 'Email sent! Check your inbox.',
          title: 'Change your password',
        },
        wrong_user: 'Not you? Sign out',
      },
    },
    payment_cancel: {
      submit: 'Confirm',
      client_request:
        'A client requested I use WeTransfer and now I don’t need it',
      different_tool: 'I found a different tool',
      extra_features: 'I need extra features that this doesn’t offer',
      not_enough_storage: 'There isn’t enough storage for me',
      not_often_large_files: 'I don’t send large files often enough',
      other: 'Other',
      other_more: 'Can you tell us more?',
      skip: 'Skip and cancel subscription',
      temp_project: 'I only needed to send large files for a temporary project',
      too_expensive: "I think it's too expensive",
    },
    payment_cancel_reason: {
      skip: 'I don’t want to give feedback',
    },
    profile: {
      label: {
        profile_title: 'Name',
        wallpaper_link: 'Link to your personal or company website',
      },
      error: {
        subdomain_name: {
          too_short:
            'We know less is more, but the custom bit of your WeTransfer URL needs to be at least 2 characters',
          domain_name: 'Sorry, someone grabbed this URL already',
          invalid:
            "Whoa, too weird—your WeTransfer URL can only contain letters and numbers (or a hyphen, if it's somewhere in between)",
          taken: 'Sorry, someone grabbed this URL already',
        },
        subdomain: {
          too_short: 'Keep going to at least 2 characters',
          too_long: 'Whoa, keep it less than 63 characters',
          invalid:
            "Whoa, too weird—your WeTransfer URL can only contain letters and numbers (or a hyphen, if it's somewhere in between)",
          domain_name: 'This URL is already taken',
        },
        default_recipient_email: {
          invalid: 'Please enter a valid email address',
        },
        wallpaper_link: {
          invalid: 'Please enter a valid web address',
        },
      },
      success: {
        subdomain: {
          updated: 'Your URL has been updated',
          available: 'Good news, this URL is available',
        },
      },
      change_background: 'Upload image',
      delete_avatar: 'Delete avatar',
      delete_background: 'Delete image',
      description: {
        title:
          'Psst, keep it to 150 characters so nothing gets cut off the page',
        wallpaper_link:
          'Clicking on the wallpapers on your page will open this website in a new tab.',
        recipient_email_locked:
          'Files sent through your profile will only go to this email address',
      },
      upload_avatar: 'Upload avatar',
      use_email_background_checkbox_label:
        'Use this wallpaper for all transfers sent through my profile',
      account_email_checkbox: 'Show email on profile',
      default_recipient_email_info:
        'You can change this email address in your <a href="/account">personal details</a>',
      change_subdomain: {
        message:
          'Change URL to <a href="%{url}">%{subdomain}.wetransfer.com</a>? Your previous one will become available right away.',
        confirm: 'Yes, change URL',
        cancel: 'Go back',
      },
    },
    fill_in_password: 'Enter your password to save these changes',
    select_all: 'Select all',
    deselect_all: 'Deselect all',
    save_changes: 'Save changes',
    save: 'Save',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    forward: 'Forward',
    proceed: 'Continue',
    delete: 'Delete',
    onboarding: {
      placeholder: {
        subdomain_name: 'choose-a-good-name',
      },
      validated: {
        subdomain_name: 'Good news – this domain is available',
      },
    },
    confirm_leave: 'Sure you want to leave this page and lose unsaved changes?',
    unsaved_changes: 'Leave page? You will lose any unsaved changes.',
    contact: {
      add_contact: 'Add contact',
      error: {
        email: {
          duplicate: 'This email address is already in your contact list',
          invalid: 'Please enter a valid email address',
        },
      },
      label: {
        company: 'Company',
        email: 'Email address',
        name: 'Name',
      },
    },
    error: {
      current_password: {
        blank: 'Please enter your current password',
        invalid: 'Password not recognized',
      },
      email: {
        blank: 'Please enter your email address',
        duplicate: 'This email address is already in your contact list',
        invalid: 'Please enter a valid email address',
        taken: 'This email address is already in use',
      },
    },
    leave: 'Leave',
    resetpassword: {
      button: {
        request_submit: 'Email me',
        reset_submit: 'Save new password',
      },
      label: {
        confirm_new_password: 'Confirm new password',
        email: 'Email address',
        new_password: 'New password',
      },
      legend: {
        request_description:
          "Locked out? We'll send you instructions to reset your password and get you back on track.",
        request_title: 'Forgot your password?',
        reset_description: 'Enter a new password to get yourself back in',
        reset_title: 'Set a new password',
        request_description_success_or_article:
          'If you have a WeTransfer account, we’ve sent you instructions to reset your password. Check out this <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">Help Center article</a> if you don’t get an email from us in the next few minutes.',
      },
    },
    signin: {
      button: {
        submit: 'Sign in',
      },
      label: {
        email: 'Email address',
        password: 'Password',
        remember_me: 'Remember me',
      },
      link: {
        forgot_password: 'Forgot password?',
      },
      title: 'Log in',
    },
    stay_on_page: 'Stay on page',
    close_panel: 'Close',
    go_back: 'Go back',
    labels: {
      email: 'Email address',
    },
    plan: {
      change: {
        month: 'Monthly (%{currency}%{price})',
        title: 'Change the plan',
        year: 'Annual (%{currency}%{price})',
      },
      change_plan: 'Change payment plan',
      month: {
        copy: 'Recurring billing',
        label: 'Monthly',
        'label-payment': 'Monthly payment',
        'sub-label': 'One bill, every month',
        title: 'WeTransfer Pro: Monthly payment',
      },
      title: 'Give your ideas the premium treatment they deserve',
      year: {
        discount: 'Save %{rate}% (ooh yeah)',
        'label-payment': 'Yearly payment',
        'sub-label': 'That’s a 17% saving. Zing',
        title: 'WeTransfer Pro: Yearly payment',
      },
      your_order: 'Your order',
    },
    save_and_continue: 'Save and continue',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Enter your password to continue',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Not now',
        true: 'Open in the WeTransfer app',
      },
      headline: 'Why not think bigger?',
      headline2: 'View files in the app?',
      subheader: 'Send and receive 200 GB with WeTransfer Pro',
      subheader2:
        'View files before you download them. Send and receive transfers, track downloads, and get notifications.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Renew now to keep enjoying all the benefits of your %{tier} account',
      account_expired_title_tier: 'Your %{tier} account has expired',
      account_inactive_title_tier: 'Ready to go %{tier}?',
      account_inactive_action: 'Yes, continue',
      account_inactive_subtitle:
        'Just one last step and you’re done. Changed your mind? It’s cool—',
      account_inactive_title: 'Ready to go Pro?',
      account_subscription_action: 'Renew now',
      account_subscription_expired: 'Your Pro account has expired',
      account_subscription_subtitle:
        'Renew now to keep your transfers, personal wallpapers and web address. Please note otherwise they will be deleted soon!',
      account_expired_action: 'Renew now',
      account_expired_subtitle:
        'Renew now to keep enjoying all the benefits of your Pro account',
      account_expired_title: 'Your Pro account has expired',
      expired_transfer_subtitle:
        'The files are no longer available. You can remove the info from your transfer overview <a>here</a>.',
      expired_transfer_title: 'This transfer has expired',
      account_email_verify_logged_out: 'Please log in to verify your email',
      account_inactive_sublink: 'cancel your order.',
      email_unverified_mobile_cta: 'Ready to verify',
      email_unverified_text:
        "We’ve sent a verification code to %{email}. <a href='%{href}'>Not you?</a>",
      email_unverified_text_link:
        "We’ve sent an email to %{email}. <a href='%{href}'>Not you?</a>",
      email_unverified_title: 'Please verify your email address',
      'force-account-verification': {
        body: 'We’ll email you a link to make sure you’re really you.',
      },
      'receiving-email':
        'Heads up! We have replaced %{receiving_email} in your profile. This means that new transfers will only appear in your transfer overview if they are sent to %{account_email}. To change this, you can update your <a href="/account">personal details</a> anytime.',
    },
    design:
      'You’ve probably noticed we’ve made a few changes round here! Many of them are things you told us you wanted to see. So enjoy exploring the new and (dare we say) improved site, and please send us any feedback here.',
    loading_error:
      'Hmm, it looks like this page is having problems loading at the moment.\nWe\'ll keep trying, or <a href="%{path}">try to refresh it</a> yourself.',
    redesign_notice:
      'You’ve probably noticed we’ve <a href="/about/redesign">made a few changes</a> round here! Many of them are things you told us you wanted to see. So enjoy exploring the new and (dare we say) improved site, and please <a href="/contact" rel="external">send us any feedback here<a/>.',
    return_to: 'back to %{pageName}',
    close: 'Close panel',
    cookie: {
      accept: 'Okay',
      text: 'We use cookies. Read <a href="/legal/terms">the legal stuff</a> (no recipes included).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Jobs',
      press: 'Press',
      terms: 'Terms',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Upgrade',
    free_limit:
      'You can’t send more than 2 GB at a time. Want to send bigger transfers?',
    compare_plans: {
      button: 'Compare plans',
      text: 'You can upgrade your plan to transfer more than 2 GB at a time.',
      title: 'Got more files to send?',
    },
    mobile: {
      cta: 'Learn more',
      header: 'Get the best of WeTransfer',
      upsell_enjoy: 'Enjoy more storage',
      upsell_one: 'Send bigger transfers',
      upsell_two: 'Personalize your WeTransfer page',
    },
    pro_limit:
      'You can’t send more than 200 GB at a time. Want to send transfers of any size?',
  },
  upsell_tiers_one: {
    text: 'Want to set passwords and expiration dates on your transfers?',
  },
  upsell_tiers_three: {
    text: 'Want to send transfers to more than %{email_limit} email addresses at a time?',
    title: 'That’s one too many',
  },
  browser: {
    assets_failed: {
      text: 'We couldn\'t load some important parts of our website.\nThey may have been blocked by your firewall, proxy or browser set-up.\nTry refreshing the page or get in touch through our <a href="https://wetransfer.zendesk.com" rel="external">help center</a>.',
      title: 'Uh-oh...',
    },
    javascript_needed:
      'You need a JavaScript-enabled browser to use WeTransfer',
  },
  languages: {
    en: 'English',
    nl: 'Nederlands',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'This offer is available until %{end_date}. The discount applies on your first year of %{user_tier}, after which the subscription will renew at the full price of %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount}% off annual Pro',
      subtitle: 'Discount code: %{coupon_code_name}',
      text_content:
        'That’s it. That’s the deal. We’re giving you a %{discount_amount}% discount on an annual Pro plan.',
      argument: {
        size_limit: 'Send and receive 200 GB file transfers',
        storage_size: 'Enjoy 1 TB of storage',
        unlimited_review: 'Create unlimited reviews',
      },
      cta_label: 'Claim discount',
      dismiss_label: 'Not now',
    },
    banner: {
      title:
        'Get %{discount_amount}% off WeTransfer Pro for a year—our best deal yet',
      cta_label: 'Upgrade',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Team up on transfers with %{first_recipient_email}',
      subtitle:
        'Invite your team to send and receive transfers on your %{user_plan} plan.',
      list: {
        overview_item: 'Shared overview of transfers',
        storage_limit_item:
          'Shared storage of %{storage_limit} extra per person',
        branding_item: 'Shared team branding',
        subscription_item: 'Shared subscription and billing',
      },
      cta: 'Invite team',
      dismiss_button: 'Not today',
    },
    second_viewing: {
      title: 'Team up on transfers with ${first_recipient_email}',
      subtitle:
        'Invite your team to send and receive transfers on your %{user_plan} plan.',
      list: {
        overview_item: 'Shared overview of transfers',
        storage_limit_item:
          'Shared storage of %{storage_limit} extra per person',
        branding_item: 'Shared team branding',
        subscription_item: 'Shared subscription and billing',
      },
      cta: 'Invite team',
      dismiss_button: 'Hide forever',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  custom_wallpaper: {
    set_custom_wallpaper: 'Set custom wallpaper',
    set_custom_wallpaper_description:
      "Give this transfer its very own wallpaper to make a great impression when people download your files—don't worry, this won't change your ",
    default_settings: 'default settings',
    upload: 'Upload',
    reset_default: 'Reset to default',
    survey_link: 'Let us know what you think',
    file_rules:
      'JPEG/PNG %{minWallpaperWidth}x%{minWallpaperHeight}, %{maxUploadSize}MB max',
    storage_size_max: 'max',
    pop_over: {
      new_feature: 'New feature',
      try_now: 'Try now',
      not_today: 'Not today',
      hide_forever: 'Hide forever',
      hint: 'Psst, you can give any transfer its very own wallpaper without changing these settings—just set a custom wallpaper before sending a transfer.',
      introductory_upsell:
        'Psst, you can now give this transfer its very own wallpaper.',
    },
  },
  notification: {
    update_account: 'Your account has been updated',
    update_password: 'Your password has been updated',
    update_subscription: 'Your payment plan has been updated',
    update_profile_success: 'Your branding has been updated',
    link_copied: 'This link has been copied to your clipboard',
    copy_link_manual: 'Link selected – copy it using %{shortcut}',
    delete_transfer_success: 'Transfer has been deleted',
    delete_transfers_success: 'Transfers have been deleted',
    update_expiry_success: 'The expiration date has been updated',
    onboarding_success:
      'This way for your transfer overview, contacts, branding, and other bits and pieces',
    add_contact_success: 'This contact has been added',
    edit_contact_success: 'This contact has been updated',
    remove_contact_success: 'This contact has been deleted',
    already_signed_in: 'You are now signed in',
    cancel_subscription_success:
      'Sorry to see you go - your subscription has been cancelled.',
    collect_app_banner_desc:
      'Preview, save and manage files from the Collect app',
    contact_added_confirmation: 'Contact was added to your transfer',
    contact_recipient_locked_text:
      'This page is for the owner to receive files. Sending to somebody else?',
    forward_ready: 'Your transfer is ready to forward',
    mobile_app_banner_desc: 'Preview, save and manage files from the app',
    mobile_app_banner_title: 'Save it in the app',
    reactivate_subscription_success:
      'Welcome back! Your account has been reactivated. ',
    refresh_transfer_upload_lost:
      'Are you sure you want to cancel the current upload?',
    update_payment_success:
      'Your payment details were successfully updated. Zing.',
    update_user: 'Your details have been updated',
    current_team_notification: "You're using %{plan} as %{currentTeam}",
    display_name_updated: 'Title updated!',
    download_started:
      "Your download has started. Once it's done, the files will be on your computer (often in the downloads folder).",
    logged_out:
      'Looks like you’ve been logged out from another browser. Please log in again.',
    project_delete:
      'Delete <strong>%{projectName}</strong> and any files you’ve added to it?',
    project_delete_success: '<strong>%{projectName}</strong> has been deleted',
    password_changed: 'Password changed',
    password_removed: 'Password removed',
  },
  alert: {
    confirm_cancel_upload_image:
      'Are you sure you want to cancel the current upload? ',
    cancel_recipient_locked: 'Cancel',
    cancel_refresh_transfer_upload_lost: 'No',
    confirm_refresh_transfer_upload_lost: 'Yes',
    go_to_transfer: 'Go to transfer',
    redirect_recipient_locked: 'Yes',
    stay: 'Stay',
    cancel_project_delete: 'Cancel',
    confirm_project_delete: 'Delete',
  },
  force_update:
    'Exciting things ahead! Please <a href="/" onClick=\'javascript:window.location.reload();\'>refresh your browser</a> to make sure you are using the latest version of WeTransfer.',
  user: {
    already_logged_in:
      "You're already signed in – are you sure you want to reset your password?",
    roles: {
      admin: 'admin',
      owner: 'owner',
      user: 'user',
    },
    sign_out_and_reset: 'Sign out and reset password',
  },
  click_here: 'Click here',
  cookiebox: {
    notice:
      '<bold>You are currently signed in</bold>, you will be signed out after clearing your cookies. Past transfers on your account won’t be affected.',
  },
  notice: {
    general_issues:
      'Things not working as they should be? We know it’s frustrating, but hang in there and we’ll get things back up and running <a target="_blank" href=%{link}>as soon as we can</a>',
    transfer_issues:
      'Having trouble with your transfer? We know it’s frustrating, but hang in there and we’ll get things back up and running <a target="_blank" href=%{link}>as soon as we can</a>',
    verification:
      'Hey, we need you to <a href="/account">confirm your email</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'About | WeTransfer',
      advertise: 'Advertise with us | WeTransfer',
      apps: 'Free apps for Mac, iOS and Android | WeTransfer Apps',
      forgot_password: 'Reset your password | WeTransfer Pro',
      help: 'How to send large files | WeTransfer Help',
      home: 'Share large files easily for free | WeTransfer',
      plus: 'Upgrade to send bigger files | WeTransfer Pro',
      sign_in: 'Log in | WeTransfer',
      sign_up: 'Sign up | WeTransfer Pro',
      upgrade: 'Upgrade | WeTransfer Pro',
      pricing:
        'Pricing | WeTransfer - Send Large Files & Share Photos Online - Up to 2GB Free',
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: 'Still haven’t found what you’re looking for?',
    },
  },
  splash: {
    footer: {
      or: 'or',
      send_files: 'I just want to send my files',
      no_thanks: 'No thanks',
    },
    heading: {
      line_1_free: 'WeTransfer is the best way to send big files',
      line_2_free: 'Get more out of WeTransfer',
      free_account: 'Welcome back. Would you like to make this official?',
    },
    plan: {
      plus: {
        feature_10: 'Customize your emails',
        feature_11: 'Store up to %{plus_storage_limit}',
        feature_12: 'Decide when transfers expire',
        feature_13: 'Password-protect your transfers',
        feature_7: 'Personalize your profile',
        feature_8: 'Create your own address book',
        feature_9: 'Customize your WeTransfer url',
      },
      free_account: {
        cta: 'Sign up for free',
        feature_1: 'No storage',
        feature_2: 'Send up to %{free_transfer_limit}',
        feature_3: 'Resend and delete transfers',
        heading: 'WeTransfer Account',
        price_label: 'Free forever',
      },
      pro: {
        cta: 'Get WeTransfer Pro',
        feature_1: '%{storage_limit_pro} storage',
        feature_2: 'Send and receive up to %{transfer_limit_pro}',
        feature_2_unlimited: 'Send and receive files with no size limits',
        feature_3: 'Resend and delete transfers',
        feature_4: 'Password-protect transfers',
        feature_5: 'Your own Pro page and URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Add %{recipient} to your team?',
      text_content:
        'Team members can access each other’s transfers with shared storage and branding. This won’t cancel your transfer.',
      cta: 'Let’s go',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link copied',
      copy: 'Copy link',
      copy_again: 'Copy again',
    },
    labels: {
      share: 'Share this transfer',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PRO TIP',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Try out portals',
        dismiss: 'Not now',
        text: 'You can invite clients and collaborators to view your work and select their favorites with <strong>portals</strong>. Here’s to fewer back-and-forth emails.',
        title: 'Need to get feedback on your work—real quick?',
      },
      'second-viewing': {
        cta: 'Try portals now',
        dismiss: 'Don’t show this again',
        text: 'Get quick feedback and share new versions—all in one place. With <strong>portals</strong>, you can keep work moving smoothly from review, to revision, to final sign off.',
        title: 'You’ve sent the work. Now what?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Go to Branding',
        text_2: 'Want to add your own videos or images?',
      },
      individual: {
        cta: 'Set up page',
        text: 'Make a great impression every time people download your files—add videos or images and choose your own URL.',
        title: 'Set the stage with your own WeTransfer page',
      },
      invitee: {
        cta: 'Got it',
        text_1:
          'With your team’s custom WeTransfer page, you’ll make a great impression every time you share your work.',
        text_2:
          'You can change your team wallpapers anytime in <strong>Branding</strong>.',
        title: 'Show off your (team) work',
      },
      not_now: 'Not now',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Set up page',
                  premium: {
                    text: 'Anyone can send you transfers of any size from your team’s WeTransfer page.',
                  },
                  text: "Anyone can send you %{transfer_limit_pro} transfers from your team's WeTransfer page",
                },
                premium: {
                  transfer_link: {
                    text: 'Anyone can send you transfers of any size from %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Anyone can send you up to %{transfer_limit_pro} transfers from %{custom_link}',
                },
              },
              premium: {
                text: 'Anyone can send you transfers of any size transfers from your team’s WeTransfer page—just give them this link.',
              },
              regular: {
                cta: 'Got it',
                text: "Anyone can send you <strong>%{transfer_limit_pro}</strong> transfers from your team's WeTransfer page––just give them this link.",
                title: 'One place for everything your team receives',
              },
            },
            sent: {
              regular: {
                cta: 'Got it',
                text: 'Welcome to your shared overview of your team’s sent transfers. You can track downloads, change expiration dates, and even edit or delete someone else’s transfers—though it might be nice to let them know before you do!',
                title: 'Manage your team’s transfers',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus is now WeTransfer Pro with 1 TB of storage — that’s 10x more. <a href="/transfers">Check it out.</a>',
  },
  refer_friend: {
    title: 'Refer friends',
    account: {
      description:
        'We’ll give you and a friend $10 each when they sign up for WeTransfer Pro or Premium. Share your referral link to get rewarded in prepaid cards, charity donations, or gift cards from hundreds of partners.',
    },
    window: {
      link: 'Get referral link',
      send_another: 'Continue',
      text: 'We’ll give you and a friend <strong>$10</strong> each when they sign up for WeTransfer Pro or Premium.',
      title: 'Refer a friend',
      title_2: 'for sending transfers.',
    },
    message: {
      success:
        'You’ve got a great friend here! Sign up for WeTransfer Pro or Premium, and you’ll each get a prepaid card, charity donation, or gift card worth $10.',
      self: 'Oh no, that referral link doesn’t look right. Please ask your friend for a new link to receive $10 when you sign up for WeTransfer Pro or Premium.',
      fallback:
        'Oh no, that referral link doesn’t look right. Please ask your friend for a new link to receive $10 when you sign up for WeTransfer Pro or Premium.',
      expired: 'Sorry, your referral link has expired.',
      dismiss: 'Dismiss',
    },
  },
  order_summary: {
    coupon: {
      link: 'Apply promo code',
      input_placeholder: 'Promo code',
      button_label: 'Apply',
      error_message:
        'Sorry, this code can only be used to save on a %{billing_period} subscription.',
      generic_error_message:
        'Sorry, this code is not compatible for this subscription',
      input_error_message: "Hmm, this isn't a valid code.",
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Total',
  },
  mobile_verify: {
    title: 'You’re all set',
    subtitle:
      'Your email has been verified—you can now use the app to send and receive transfers.',
    cta: 'Open the WeTransfer app',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Your current plan of <b>%{formattedintervaltotal}</b> /%{subscriptioninterval} will automatically renew on <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Your current plan of <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} (%{membercount} x %{tieramount}) will automatically renew on <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Your next payment date is <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> /%{interval}',
    team_upgrade_calculation: '(%{membercount} members x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'No size limits on transfers',
    premium_feature_two: 'Unlimited storage',
    premium_feature_three: 'Unlimited portals and reviews',
    premium_feature_four:
      'See <a class="all-benefits-link" href="%{all_benefits_href}">all benefits</a>',
    premium_switch_cta_text: 'Switch to premium',
    pill_text: 'Current plan',
    member_count: '%{membercount} members',
    see_all_benefits: 'See all plan benefits',
    pending_downgrade_current_subscription:
      'Your workspace subscription has been cancelled and will end on <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Changed your mind? Don’t panic, it’s easy to get things back up and running.',
    pending_downgrade_reactivate_cta: 'Reactivate subscription',
    pending_downgrade_payment: 'You have no upcoming payments',
    update_payment_cta: 'Update payment details',
    cancel_plan:
      'If you cancel your subscription, you can access your %{planName} workspace until %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Your workspace will then be downgraded to the free plan, and your existing transfers will expire after 28 days.',
    pending_payment_text:
      'To see your plan and payment information, please complete your payment or cancel your order.',
    learn_more: 'Learn more about plans and pricing',
  },
  time: {
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Under a minute remaining',
        one: 'About 1 minute remaining',
        other: 'About %{count} minutes remaining',
      },
      hours: {
        one: 'About an hour remaining',
        other: 'About %{count} hours remaining',
      },
    },
  },
  download: {
    shortcut: 'Press %{command} to see the<br />download progress',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Send up to %{size}',
    progress: {
      busy: 'Transferring...',
    },
    buttons: {
      add: 'Add files',
      transfer: 'Transfer',
      forward: 'Forward',
    },
    forward: {
      done: 'Forward complete',
    },
    friend_email: {
      title: "Friend's email",
      more: 'Add more friends',
    },
    your_email: {
      title: 'Your email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfer complete',
      link: 'Copy your download link:',
      copied: {
        title: 'Copied!',
        text: 'The download link has been copied.',
      },
    },
    more_html: 'Add more files<span>(%{size} left)</span>',
    too_many_recipients:
      "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    completed: '%{size} of %{total} completed',
    addresses: {
      one: '%{count} address',
      other: '%{count} addresses',
      remove: 'Do you want to remove %{address} from your previous recipients?',
    },
    ads: {
      plus: {
        title: 'Get more out<br />of WeTransfer<br />with Pro',
        text: "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus2: {
        title: 'Impress<br />with your<br />own custom download page',
        text: "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus3: {
        title: 'Manage<br />your transfers smarter',
        text: "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus4: {
        title: 'Get extra protection<br />for your files',
        text: "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      facebook: {
        title: 'Join the<br />WeTransfer<br />community<br />on Facebook',
        text: "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email: 'Sorry, only email is supported when resending a transfer.',
      connect_twitter:
        'Your Twitter account is not yet connected to WeTransfer.',
      connect_facebook:
        'Your Facebook account is not yet connected to WeTransfer.',
      transferproblems: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      limitreached: {
        title: 'Storage Limit',
        text: 'You reached your 1 TB limit. Delete some old transfers to send new files',
      },
      blocked: {
        title: 'Transfer problem',
        text: 'Computer says no. Sorry, but you have been blocked from WeTransfer.',
      },
      upload_error: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, this transfer has already been deleted so it cannot be forwarded.',
      },
      startswithdot: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      startswithspace: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      containsreturn: {
        title: 'Oops',
        text: "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again.",
      },
      alreadyinlist: {
        title: 'Yikes',
        text: "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!",
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      filetoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      zerobytes: {
        title: 'Whoops',
        text: 'One (or more) of your files is empty or could not be read.',
      },
      ioerror: {
        title: 'Fail',
        text: "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly.",
      },
      filenametoolong: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it.",
      },
      nofolders: {
        title: 'Uh-oh',
        text: "Sorry, uploading folders doesn't work yet. Try zipping it first.",
      },
      nofiles: {
        title: 'Oops',
        text: "You haven't actually added any files yet.",
      },
      norecipients: {
        title: 'Doh!',
        text: 'Looks like you forgot to enter any email addresses to send to.',
      },
      toomanyrecipients: {
        title: 'Yikes',
        text: 'Too many recipients.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Your message is longer than a novel. Please make it shorter.',
      },
      nosender: {
        title: 'Seriously?',
        text: 'You forgot to enter your own email address. How could you?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Your email address appears to be incorrect. Mind your spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: "It looks like you haven't copied the link.",
      },
      recipientemailinvalidformat: {
        title: 'Oops',
        text: "You entered one of your friend's email addresses incorrectly.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash.",
      },
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>",
      },
      recipients_tip: {
        title: 'Tip',
        text: 'You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Pop your own email address in here so we can contact you when the files have been downloaded.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'You can now change the expiry date of your Pro transfers.',
      },
      message_tip: {
        title: 'Tip',
        text: "Want to send your friends a message along with the files? Here's your chance - but you don’t have to.",
      },
      share_tip: {
        title: 'Tip',
        text: 'Change the way you share your files. Send them by email or grab a download link.',
        text_plus:
          'Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link.',
      },
      download: {
        title: '',
        chrome:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        firefox:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        safari:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        old_explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        settings:
          'You can change your default download location in your browser settings.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding: 'Forwarding this transfer will clear the form, are you sure?',
    is_busy: "Sorry, we can't do this right now",
  },
  mobile_app: {
    remember_choice: "Don't show this message again",
    uploader: {
      description:
        'Our site is not optimised for mobile right now. But we do have a shiny mobile app.',
      app_name: 'WeTransfer',
      download: 'Download the App',
      continue: 'Continue to WeTransfer.com',
    },
    downloader: {
      title: 'Your files are ready for download!',
      description_ios:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>" is a pretty good app for that.',
      description_android:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>" is a pretty good app for that.',
      continue: 'Understood',
    },
  },
};
